import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { Router, CanActivate } from "@angular/router";
//import * as geofirex from 'geofirex';
import { formatDate } from "@angular/common";
import { Observable, BehaviorSubject, from } from "rxjs";
import * as Moment from "moment";
import { extendMoment } from "moment-range";
import { AgmMap } from "@agm/core";
//import { GeoFireQuery } from 'geofirex';
import { ItemEvent, Photos, questions } from "../models/evidence";
import { UserService } from "../core/user.service";
import { ModulosService } from "../core/modulos.service";
import { AuthService } from "../core/auth.service";
import { StorageService } from "../core/storage.service";
import { UtilsService } from "../core/helper/utils.helper";

import { ExcelService } from "../services/excel.service";
import { MenuComponent } from "../components/menu/menu.component";

import { MatDialog } from "@angular/material";
import { environment } from "environments/environment";

// import {
//   Image,
//   GalleryService,
// } from '@ks89/angular-modal-gallery';

import * as jspdf from "jspdf";
import domToPdf from "dom-to-pdf";

declare let html2canvas: any;
//var domToPdf = require('dom

import { ScriptService } from "../script.service";
import * as pdfMake from "pdfmake";
//import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { TimezoneConversionService } from "@app/core/timezone-conversion.service";
import * as crypto from "crypto-js";
import { ShareDialogComponent } from "@app/detail-order/components/share-dialog/share-dialog.component";
import { NgxSpinnerService } from "ngx-spinner";
import { EncryptionDecryptionService } from "../services/encryption-decryption.service";
import {
  ButtonsConfig,
  ButtonsStrategy,
  Description,
  DescriptionStrategy,
  Image,
  KS_DEFAULT_BTN_CLOSE,
  KS_DEFAULT_BTN_DOWNLOAD,
  KS_DEFAULT_BTN_FULL_SCREEN,
  PreviewConfig,
} from "@ks89/angular-modal-gallery";
import { SlideConfig } from "@ks89/angular-modal-gallery/lib/model/slide-config.interface";
import { FormsService } from "@app/core/forms.service";
import { PermissionService } from "../core/permission.service";
import { HostListener } from "@angular/core";

import { ModalGenericService } from "@app/services/modal-generic.service";
import { TranslateService } from "@ngx-translate/core";
import { take } from "rxjs/operators";
import { OrdersService } from "../orders.service";
import { TransferActivityComponent } from "@app/transfer-activity/transfer-activity.component";

interface itemsConfigObj {
  name: string;
  rows: itemsConfigDetails[];
}

interface itemsConfigDetails {
  id?: number;
  title: string;
  nextScreen: string;
  url_icon: string;
  questionary_id?: number;
  isExtraItem?: boolean;
  isDeleted?: boolean;
}

interface ordenes_pdf {
  id: string;
  order_number: string;
  customer_name: string;
  order_name: string;
  address: string;
  users_all: boolean;
  start_date: string;
  end_date: string;
  latitude: string;
  longitude: string;
  users: any[];
  status: string; //1 -> pendiente, 2 -> proceso, 3 -> completado
  user_uid: string;
  user_name: string;
  geolocation: any;
  address_checkIn?: string;
  evidence: ItemEvent[];
  photo_evidence: Photos[];
}

interface ordenesObj {
  id: string;
  order_number: string;
  customer_name: string;
  order_name: string;
  address: string;
  users_all: boolean;
  start_date: string;
  end_date: string;
  latitude: string;
  longitude: string;
  users: any[];
  status: string; //1 -> pendiente, 2 -> proceso, 3 -> completado
  authorization_status: number; //1 -> pendiente, 2 -> aceptado, 3 -> rechazado
  user_uid: string;
  departamento?: string;
  sucursal?: string;
  tipo?: string;
  qr_equipment?: string;
  scheduled_equipment_uid?: string;
  user_name: string;
  geolocation: any;
  address_checkIn?: string;
  category?: string;
  evidence: ItemEvent[];
  evidence_first_id: string;
  description_photo_evidence: string;
  photo_evidence: Photos[];
  classification_category_name?: string;
  classification_subcategory_name?: string;
  classification_category_uid?: string;
  classification_subcategory_uid?: string;
  customer_uid?: string;
  is_utc?: any;
  start_date_utc?: any;
  end_date_utc?: any;
  history_transfer_names: any[];
  history_transfer_names_array: any[];
  pinUrl?: string;
  dynamic_url_web?: string;
}

interface usersObj {
  text: string;
  id: string;
}

export interface PhotosTmp {
  item_evidence_id: string;
  photo_name: string;
  thumb_name: string;
  url_photo: string;
  url_thumb: string;
}

export interface SignaturesTmp {
  item_evidence_id: string;
  signature_name: string;
  signed_customer_name?: string;
  url: string;
}

interface MultiPhotosObj {
  id: string;
  title: string;
  descripcion: string;
  evidencia: Photos[];
}

interface PreguntasObj {
  id?: number;
  title: string;
  questions: questions[];
}

interface itemsExtra {
  doc?: string;
  items_extra: itemsConfigDetails[];
}

interface SignaturesObj {
  id?: string;
  title: string;
  firmas: SignaturesTmp[];
}

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  providers: [ExcelService],
})
export class DashboardComponent implements OnInit {
  buttonsConfigCustom: ButtonsConfig = {
    visible: true,
    strategy: ButtonsStrategy.CUSTOM,
    buttons: [
      // KS_DEFAULT_BTN_ROTATE,
      // KS_DEFAULT_BTN_FULL_SCREEN,
      // KS_DEFAULT_BTN_DOWNLOAD,
      KS_DEFAULT_BTN_CLOSE,
    ],
  };

  customDescription: Description = {
    strategy: DescriptionStrategy.ALWAYS_VISIBLE,
    imageText: "",
    numberSeparator: "/",
    beforeTextDescription: " Comentarios: ",
  };

  previewConfigCustomSize: PreviewConfig = {
    number: 5,
    visible: true,
    size: { width: "90px", height: "90px" },
  };

  slideConfig: SlideConfig = {
    sidePreviews: {
      show: true,
      size: {
        width: "100px",
        height: "100px",
      },
    },
  };

  capturedImage;

  @ViewChild("AgmMap") agmMap: AgmMap;
  @ViewChild("screen") screen: ElementRef;
  @ViewChild("menuHeader") menuHeader: MenuComponent;

  //geo = geofirex.init(firebase);
  //points: Observable<any[]>;
  radius = new BehaviorSubject(1500);
  today = formatDate(new Date(), "yyyy-MM-dd", "en");
  moment = extendMoment(Moment);
  isShown: boolean = false;
  isSearching: boolean = false;
  showInfoPoint: boolean = false;
  showMiniDashboard: boolean = true;
  reference;
  //previous;
  title = "";
  in = "";
  out = "";
  user = "";
  address = "";
  description = "";
  photo_evidence: Photos[] = [];
  all_reports = [];
  scrHeight: any;
  scrWidth: any;

  order_pin_selected: ordenesObj = {
    id: "",
    order_number: "",
    customer_name: "",
    order_name: "",
    address: "",
    users_all: false,
    start_date: "",
    end_date: "",
    latitude: "",
    longitude: "",
    users: [],
    status: "", //1 -> pendiente, 2 -> proceso, 3 -> completado
    user_uid: "",
    user_name: "",
    geolocation: null,
    address_checkIn: "",
    evidence: [],
    evidence_first_id: "",
    description_photo_evidence: "",
    photo_evidence: [],
    authorization_status: null,
    history_transfer_names: [],
    history_transfer_names_array: [],
  };

  user_email = "-----------------------------";

  //defaultCenter = {lat: 22.7376, lng: -101.3927};
  //currentCenter = Object.assign({}, this.defaultCenter);

  /*
  geoQuery: GeoFireQuery;
  collection: firebase.firestore.CollectionReference;
  testDoc;
  docId;
  */

  differ: any;

  pageActual: number = 1;

  ordenes: ordenesObj[] = [];
  ordenespin: ordenesObj[] = [];
  ordenes_clone: ordenesObj[] = [];
  users: usersObj[] = [];
  departamentos: usersObj[] = [];
  tipos: usersObj[] = [];
  sucursales: usersObj[] = [];
  clientes: usersObj[] = [];
  equipments: usersObj[] = [];
  categories: usersObj[] = [];
  subcategories: usersObj[] = [];
  public user_selected: string = "";
  public ordenesForDashboard: ordenesObj[] = [];
  private ordenesSubject = new BehaviorSubject([]);
  public ordenes$: Observable<ordenesObj[]>;
  public ordenespin$: Observable<ordenesObj[]>;

  orderSelected: ordenesObj;

  current_order: ordenesObj;
  currentImages: Image[] = [];

  public orders_by_block = 100;

  filter_select = [
    "Todas",
    "Abiertas",
    "Cerradas",
    "En revisión",
    "Autorizadas",
    "Rechazadas",
    "Archivadas",
  ];

  url_map = "";
  url_link = "";
  url_logo_client = "";

  order_pdf: ordenes_pdf = {
    id: "",
    order_number: "",
    customer_name: "",
    order_name: "",
    address: "",
    users_all: false,
    start_date: "",
    end_date: "",
    latitude: "",
    longitude: "",
    users: [],
    status: "", //1 -> pendiente, 2 -> proceso, 3 -> completado
    user_uid: "",
    user_name: "",
    geolocation: null,
    address_checkIn: "",
    evidence: [],
    photo_evidence: [],
  };

  //public items_config: itemsConfigObj = null;
  public items_config: itemsConfigDetails[] = [];
  list_photos: PhotosTmp[] = [];
  list_signatures: SignaturesTmp[] = [];
  array_questionaries: PreguntasObj[] = [];
  array_comments: PreguntasObj[] = [];
  array_evidence: MultiPhotosObj[] = [];
  array_signatures: SignaturesObj[] = [];

  template_pdf =
    '<HTML> <HEAD> <META charset=UTF-8"> <TITLE></TITLE> <STYLE type="text/css"> .break-before {page-break-before: always;} .no-break {page-break-inside: avoid;} .clearfix:after {content: " "; visibility: hidden; display: block; height: 0; clear: both;} html {zoom: 0.64; font-family: Arial, Helvetica, sans-serif;}  body { height:100vh; margin-top: 0px;margin-left: 0px; font-family: Arial, Helvetica, sans-serif;} #page {position:relative; overflow: hidden;margin: 22px 0px 20px 17px;padding: 0px;border: none;width: 799px;height: auto;} #page #img_logo {width:auto;height: 100px;} #line { border: 1px solid #9FAFC1; margin-top: 30px;} h2 { font-size: 2.0em; color: #3B4754; margin-bottom: 4px !important; } #s_order { color: #9FAFC1} #icons_report { margin-right: 15px;}  .toolboxItems{ 	margin-top: 50px;  	margin-bottom:20px; }  .toolboxItems .image, .toolboxItems .label {   display: table-cell;   width: 25px;   vertical-align: middle;   padding: 0px; }  .toolboxItems .label {   width: 100%;   color: #3B4754;   font-size: 1.2em; } /* .toolboxItems .label_description {   width: 100%;   color: #3B4754;   font-size: 1.2em;   margin-left:15px; } */ .toolboxItems .image_items {   display: table-cell;   width: auto;   vertical-align: middle;   padding: 5px;   margin-left: 10px;   background-color: #F45B69;   border-radius: 10px; }  .toolboxItems_2{ 	margin-top: 20px; }  .toolboxItems_2 .image, .toolboxItems_2 .label {   display: inline-block;   width: 25px;   vertical-align: middle;   padding: 0px; }  .toolboxItems_2 .label {   width: 190px;   color: #3B4754;   font-size: 1.2em; }  .lbl_questions{  	font-size: 1.0em;  	color: #3B4754; } </STYLE> </HEAD>  	<BODY> 		<DIV id="page"> 			<TABLE style="width:100%"> 			<TR> 				<TD> 					<DIV> 				 				            						{16} 					</DIV>  				</TD>	 				<TD style="text-align: right;"> 					<DIV> 				 				            						<img src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Flogo.svg?alt=media&token=bf283e6d-29fd-437f-a156-ff6a7acc09f4" id="img_logo"> 					</DIV>  				</TD>	 			</TR> 		</TABLE> 			<HR id="break-before"> 			 <TABLE style="width:100%; padding:10px"> 			  <TR> 				<td width="50%"> 					<h2>{10}</h2> 					<span id="s_order">No de Orden:{0}</span> 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fcalendar.svg?alt=media&token=95c3ce70-330a-46e0-9c21-7149b8a3d2f6" alt="" />				   						</div>  						<div class="label"> 						   <label><b>{14}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fclock.svg?alt=media&token=157af8d0-4e0b-4a22-8222-25cbab896ad7" alt="" />				   						</div>  						<div class="label"> 						   <label><b>Check In:  <nobr>{3}</nobr></b></label> 						   <label><b>Check Out: {4}</b></label>                <label><b>Duration: {15}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Flocation.svg?alt=media&token=8b152ff7-fabc-4753-b1b3-033d4195d83b" alt="" />				   						</div>  						<div class="label"> 						   <label><b>{11}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fuser.svg?alt=media&token=6068a6d4-5030-4022-b4e8-bba01428a5e8" alt="" />				   						</div>  						<div class="label"> 						   <label><b>Username {12}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 						</div>  						<div class="label"> 						   <label><b>URL: {17}</b></label> 						</div> 					</div> 					 					 				</td> 				<td width="50%"> 					{13} 				</td> 			  </TR> 			</TABLE>  			<HR id="break-before"> 			 			{6} 			 			 		</DIV> 		 	</BODY> </HTML>';
  @Input() template: string = `<div></div>`;

  public bounds: any;
  public _totalPromDuracion = 0;
  public _totalMarksVisible = 0;
  public _totalPromEventos = 0;
  public _totalPromDistance = 0;

  public selectedPersonId: string[];
  public selectedDepartmentId: string[];
  public selectedSucursalId: string[];
  public selectedTipoId: string[];
  public selectedClienteId: string[];
  public selectedEquipmentId: string[];
  public selectedCategoryId: string[];
  public selectedSubcategoryId: string[];
  showEmptyReports: boolean = false;
  isSearching2: boolean = false;
  stylewidth: string = "100%";
  statusSelect: string = "Todas";
  estatusSelect: string = "Todas";
  selectMenu: boolean = true;
  filter_apply: string = "";
  categories_all: any;
  public _totalPromActividades = 0;
  subcategories_category: usersObj[] = [];
  showMap: boolean = false;

  get MarkersVisible(): any[] {
    if (!this.bounds) return [];
    return this.ordenesForDashboard.filter((o) =>
      this.bounds.contains({
        lat: parseFloat(o.latitude),
        lng: parseFloat(o.longitude),
      })
    );
  }

  get totalMarkersVisible() {
    return this._totalMarksVisible;
  }

  get totalPromDuracion() {
    if (!this.bounds || this.MarkersVisible.length == 0) return 0;
    return (
      this.MarkersVisible.filter((f) => f.end_date).reduce(
        (t1, t) =>
          (t1 += Moment(t.end_date).diff(Moment(t.start_date), "seconds")),
        0
      ) / this.MarkersVisible.filter((f) => f.end_date).length
    );
  }

  get totalPromDuracionLabel() {
    return this.toMiniDashboardLabel(this._totalPromDuracion);
  }

  get totalPromDistance() {
    if (!this.bounds || this.MarkersVisible.length - 1 == 0) return 0;
    return (
      this.MarkersVisible.reduce(
        (t, t1, t2, t3) =>
          (t += t3[t2 + 1]
            ? this.utilsService.distance(
                t1.latitude,
                t1.longitude,
                t3[t2 + 1].latitude,
                t3[t2 + 1].longitude,
                "K"
              )
            : 0),
        0
      ) /
      (this.MarkersVisible.length - 1)
    );
  }

  get totalPromDistanceLabel() {
    return this._totalPromDistance;
  }

  get totalPromEventos() {
    if (!this.bounds || this.MarkersVisible.length - 1 == 0) return 0;
    return (
      this.MarkersVisible.slice()
        .sort((a, b) =>
          Moment(a.end_date).isBefore(Moment(b.start_date)) ? 1 : -1
        )
        .map((m, m1, m2) =>
          m.end_date != "" && m2[m1 + 1]
            ? Moment(m.end_date).diff(Moment(m2[m1 + 1].start_date), "seconds")
            : 0
        )
        .reduce((t, t1, t2, t3) => (t += t1), 0) / this.MarkersVisible.length
    );
  }

  get totalPromEventosLabel() {
    return this.toMiniDashboardLabel(this._totalPromEventos);
  }

  get TiposList() {
    return (
      this.tipos &&
      this.tipos.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) {
          return 1;
        }
        if (a.text.toUpperCase() < b.text.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    );
  }

  get SucuralesList() {
    return (
      this.sucursales &&
      this.sucursales.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) {
          return 1;
        }
        if (a.text.toUpperCase() < b.text.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    );
  }

  get DapartamentosList() {
    return (
      this.departamentos &&
      this.departamentos.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) {
          return 1;
        }
        if (a.text.toUpperCase() < b.text.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    );
  }

  get ClientesList() {
    return (
      this.clientes &&
      this.clientes.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) {
          return 1;
        }
        if (a.text.toUpperCase() < b.text.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    );
  }

  get EquipmentsList() {
    return (
      this.equipments &&
      this.equipments.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) {
          return 1;
        }
        if (a.text.toUpperCase() < b.text.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    );
  }

  get UserList() {
    return (
      this.users &&
      this.users.sort(function (a, b) {
        if (a.text && b.text) {
          if (a.text.toUpperCase() > b.text.toUpperCase()) {
            return 1;
          }
          if (a.text.toUpperCase() < b.text.toUpperCase()) {
            return -1;
          }
        }
        return 0;
      })
    );
  }

  get CategoriesList() {
    return (
      this.categories &&
      this.categories.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) {
          return 1;
        }
        if (a.text.toUpperCase() < b.text.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    );
  }

  get SubcategoriesList() {
    return (
      this.subcategories &&
      this.subcategories.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) {
          return 1;
        }
        if (a.text.toUpperCase() < b.text.toUpperCase()) {
          return -1;
        }
        return 0;
      })
    );
  }

  startRange: string;
  endRange: string;
  selectedDate: string;
  isRange = false;

  collapseSum = true;

  period: string;
  permissions: any = {};
  currentTimeZone: any;
  originalStartRange = "";
  originalEndRange = "";

  totalitems: number;
  selectedTipoIdstring: string;
  selectedPersonId_string: string;
  selectedClienteIdstring: string;
  selectedEquipmentstring: string;
  selectedSucursalIdstring: string;
  selectedDepartmentId_string: string;
  subcategories_list: usersObj[];
  selectedCategoryIdstring: string;
  selectedSubcategoryIdstring: string;
  selectedSubCategoryIdstring: string;

  name_category = "Categoría";
  name_subcategory = "Subcategoría";

  constructor(
    private cd: ChangeDetectorRef,
    private router: Router,
    public dialog: MatDialog,
    public userService: UserService,
    public formService: FormsService,
    public authService: AuthService,
    public storageService: StorageService,
    public utilsService: UtilsService,
    private excelService: ExcelService,
    public modulosService: ModulosService,
    private spinner: NgxSpinnerService,
    public permisionService: PermissionService,
    private modalGeneric: ModalGenericService,
    public translateService: TranslateService,
    public ordersService: OrdersService,
    private timezoneConversionService: TimezoneConversionService,
    private encryptDecryptService: EncryptionDecryptionService
  ) {
    this.getScreenSize();
    this.currentTimeZone = this.storageService.getTimeZoneConfig();
    this.showMap =
      this.storageService.getCurrentStatusMapDashboard() === "true";
  }
  getNamesCategories() {
    this.userService.getDataClassification().then((response: any) => {
      this.name_category = response[0].name_category;
      this.name_subcategory = response[0].name_subcategory;
    });
  }

  ngOnInit() {
    if (this.authService.customerDB != null) {
      this.userService.customerDB = this.authService.customerDB;
      this.modulosService.customerDB = this.authService.customerDB;
      this.userService.customerSelected = this.authService.customerSelected;

      this.userService.getCurrentUser().then((user) => {
        this.user_email = user.email;
        this.url_logo_client = this.authService.customerSelected.url_logo;
      });

      this.modulosService.getModulos();
      let filtersDashboard = JSON.parse(
        this.storageService.getFiltersDashboard()
      );
      if (filtersDashboard && filtersDashboard.isSearching) {
        if (filtersDashboard.hasOwnProperty("isSearching"))
          this.isSearching = filtersDashboard.isSearching;
        if (filtersDashboard.hasOwnProperty("nameEvent"))
          this.user_selected = filtersDashboard.nameEvent;
        if (filtersDashboard.hasOwnProperty("typeEvent"))
          this.selectedTipoId = filtersDashboard.typeEvent;
        if (filtersDashboard.hasOwnProperty("oficce"))
          this.selectedSucursalId = filtersDashboard.oficce;
        if (filtersDashboard.hasOwnProperty("role"))
          this.selectedDepartmentId = filtersDashboard.role;
        if (filtersDashboard.hasOwnProperty("user"))
          this.selectedPersonId = filtersDashboard.user;
        if (filtersDashboard.hasOwnProperty("client"))
          this.selectedClienteId = filtersDashboard.client;
        if (filtersDashboard.hasOwnProperty("equipment"))
          this.selectedEquipmentId = filtersDashboard.equipment;
        if (filtersDashboard.hasOwnProperty("category"))
          this.selectedCategoryId = filtersDashboard.category;
        if (filtersDashboard.hasOwnProperty("subcategory"))
          this.selectedSubcategoryId = filtersDashboard.subcategory;
        if (filtersDashboard.hasOwnProperty("selectedDate"))
          this.selectedDate = filtersDashboard.selectedDate;
        if (filtersDashboard.hasOwnProperty("startRange"))
          this.startRange = filtersDashboard.startRange;
        if (filtersDashboard.hasOwnProperty("endRange"))
          this.endRange = filtersDashboard.endRange;
        this.opensearchform();
      }
    }

    this.getNamesCategories();
  }

  update(v) {
    this.radius.next(v);
  }

  changeStatusMap() {
    this.showMap = !this.showMap;
    this.storageService.setStatusMapDashboard(this.showMap);
    console.log(
      "STATUS MAP ",
      this.storageService.getCurrentStatusMapDashboard()
    );
  }

  MarkerEvent(order, infowindow) {
    if (
      order.status == 2 &&
      (order.authorization_status === 0 || order.authorization_status === null)
    ) {
      console.log("abierta");
    }
    var order_id = order.id;
    this.userService.getInfoOrder(order_id).then((order_data: any) => {
      if (order_data != null) {
        var category_details: any = this.categories_all.docs
          .map((d) => d.data())
          .find((f) => f.category == order_data.category);

        let names_array_total = [];
        let names_array = {
          name: order_data.user_name,
          uid: order_data.user_uid,
          photo: order_data.photoUrl,
        };

        names_array_total.push(names_array);

        if (
          order_data.history_transfer_names &&
          order_data.history_transfer_names.length > 0
        ) {
          for (let item_user_history of order_data.history_transfer_names) {
            let search_uid = names_array_total.findIndex(
              (object) => object.uid === item_user_history.uid
            );
            if (search_uid === -1) {
              names_array_total.push({
                name: item_user_history.name,
                uid: item_user_history.uid,
              });
            }
          }
        }

        this.order_pin_selected.id = order_data.firebase_id;
        this.order_pin_selected.order_number = order_data.order_number;
        this.order_pin_selected.customer_name = order_data.customer_name;
        this.order_pin_selected.order_name = order_data.order_name;
        this.order_pin_selected.address = order_data.address;
        this.order_pin_selected.users_all = order_data.users_all;
        this.order_pin_selected.start_date = order_data.start_date;
        this.order_pin_selected.end_date = order_data.end_date;
        this.order_pin_selected.latitude = order_data.latitude;
        this.order_pin_selected.longitude = order_data.longitude;
        this.order_pin_selected.users = order_data.users;
        this.order_pin_selected.status = order_data.status;
        this.order_pin_selected.user_uid = order_data.user_uid;
        this.order_pin_selected.user_name = order_data.user_name;
        this.order_pin_selected.geolocation = order_data.geolocation;
        this.order_pin_selected.address_checkIn = order_data.address_checkIn;
        this.order_pin_selected.evidence = [];
        this.order_pin_selected.evidence_first_id = "";
        this.order_pin_selected.description_photo_evidence = "";
        this.order_pin_selected.photo_evidence = [];
        (this.order_pin_selected.tipo =
          category_details && category_details.name
            ? category_details && category_details.name
            : ""),
          (this.order_pin_selected.category = order_data.category);
        this.order_pin_selected.history_transfer_names_array =
          names_array_total;
        this.order_pin_selected.authorization_status =
          order_data.authorization_status;
        this.order_pin_selected.classification_category_name =
          order_data.classification_category_name;
        this.order_pin_selected.classification_subcategory_name =
          order_data.classification_subcategory_name;
        console.log("this.order_pin_selected", this.order_pin_selected);
        console.log("this.order_pin_selected", order_data);

        this.loadEvideByOrder();
      } else {
        console.log("No se encontro la orden.");
      }
    });
  }

  loadEvideByOrder() {
    //this.userService.customerSelected = this.authService.customerSelected;
    //this.userService.customerDB.app
    //.firestore()
    this.userService
      .getTenancyParams()
      .collection("orders")
      .doc(this.order_pin_selected.id)
      .collection("evidence")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc: any) => {
          this.order_pin_selected.evidence.push({
            id: doc.data().id,
            title: doc.data().title,
            description: doc.data().description,
            photos: doc.data().photos,
            last_signed_name: doc.data().last_signed_name,
            last_signed_customer_name: doc.data().last_signed_customer_name,
            signatures: doc.data().signatures,
            questions: doc.data().questions,
            itemId_assigned: doc.data().itemId_assigned,
            maps: doc.data().maps,
          });

          if (doc.data().photos.length > 0) {
            this.order_pin_selected.description_photo_evidence =
              doc.data().description;
            this.order_pin_selected.photo_evidence = doc.data().photos;
            this.order_pin_selected.evidence_first_id = doc.data().id;
          }
        });

        console.log("NEW ORDER -> " + this.order_pin_selected.id);
        //this.loadUrlPhotos(this.order_pin_selected);
      })
      .catch((err) => {
        console.log("Error Firebae -> " + err);
      });
  }

  checkMarkersInBounds(bounds) {
    console.log("entra aqui mero");
    console.log(bounds);
    this.bounds = bounds;
    let inBoundsEventsWEndDate = this.MarkersVisible.filter(
      (f) => f.end_date
    ).slice(0);

    this._totalMarksVisible = this.MarkersVisible.length;
    console.log("total de ordenes visibles");
    console.log(this.MarkersVisible.length);
    console.log(this.MarkersVisible);
    this._totalPromDuracion =
      inBoundsEventsWEndDate.reduce(
        (t1, t) =>
          (t1 += Moment(t.end_date).diff(Moment(t.start_date), "seconds")),
        0
      ) / this.MarkersVisible.filter((f) => f.end_date).length;
    this._totalPromEventos =
      inBoundsEventsWEndDate
        .sort((a, b) =>
          Moment(a.end_date).isBefore(Moment(b.start_date)) ? 1 : -1
        )
        .map((m, m1, m2) =>
          m2[m1 + 1]
            ? Math.abs(
                Moment(m.start_date).diff(
                  Moment(m2[m1 + 1].end_date),
                  "seconds"
                )
              )
            : 0
        )
        .reduce((t, t1, t2, t3) => (t += t1), 0) /
      (inBoundsEventsWEndDate.length - 1);
    this._totalPromDistance =
      this.MarkersVisible.reduce(
        (t, t1, t2, t3) =>
          (t += t3[t2 + 1]
            ? this.utilsService.distance(
                t1.latitude,
                t1.longitude,
                t3[t2 + 1].latitude,
                t3[t2 + 1].longitude,
                "K"
              )
            : 0),
        0
      ) /
      (this.MarkersVisible.length - 1);

    console.log("VISIBLE SLOS MARKERS ", this.MarkersVisible);

    this.users = this.MarkersVisible.map((u) =>
      Object({ id: u.user_uid, text: u.user_name })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );
    this.departamentos = this.MarkersVisible.map((u) =>
      Object({ id: u.departamento, text: u.departamento })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );
    this.sucursales = this.MarkersVisible.map((u) =>
      Object({ id: u.sucursal, text: u.sucursal })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );
    this.tipos = this.MarkersVisible.map((u) =>
      Object({ id: u.category, text: u.tipo })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );
    this.clientes = this.MarkersVisible.map((u) =>
      Object({
        id: u.customer_uid,
        text: u.customer_name == null ? "" : u.customer_name,
      })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );

    this.equipments = this.MarkersVisible.map((u) =>
      Object({
        id: u.scheduled_equipment_uid,
        text: u.qr_equipment == null ? "" : u.qr_equipment,
      })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );

    this.categories = this.MarkersVisible.map((u) =>
      Object({
        id: u.classification_category_uid,
        text:
          u.classification_category_name == null
            ? ""
            : u.classification_category_name,
      })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );
    this.subcategories = this.MarkersVisible.map((u) =>
      Object({
        id: u.classification_subcategory_uid,
        text:
          u.classification_subcategory_name == null
            ? ""
            : u.classification_subcategory_name,
      })
    ).filter(
      (value, index, self) =>
        self.findIndex((f) => f.text == value.text) === index
    );
  }

  showTool() {
    this.showInfoPoint = true;
  }

  hideTool() {
    this.showInfoPoint = false;
  }
  hideMiniDashboard() {
    this.showMiniDashboard = false;
  }

  setPeriod(fecha: string) {
    this.order_pin_selected.id = null;
    this.selectedDate = fecha;

    this.startRange = "";
    this.endRange = "";

    console.log("1111111111111 5 ");
    this.Period();
  }

  Period() {
    console.log("~ fecha --- ", this.selectedDate);
    if (!this.selectedDate) {
      this.selectedDate = formatDate(
        this.timezoneConversionService.timezoneClientOffset(
          new Date().toDateString() + " 00:00:00",
          this.currentTimeZone.reference
        ),
        "yyyy-MM-dd HH:mm:ss",
        "en"
      );
    } else {
      this.selectedDate = formatDate(
        this.timezoneConversionService.timezoneClientOffset(
          this.selectedDate.split(" ")[0] + " 00:00:00",
          this.currentTimeZone.reference
        ),
        "yyyy-MM-dd HH:mm:ss",
        "en"
      );
    }
    if (
      !this.startRange ||
      !this.endRange ||
      this.startRange == "" ||
      this.endRange == ""
    ) {
      this.isRange = false;
    } else {
      this.isRange = true;
    }

    let filters = {
      isSearching: this.isSearching,
      isRange: this.isRange,
      nameEvent: this.user_selected,
      // typeEvent : this.selectedTipoId,
      typeEvent: this.selectedTipoIdstring,

      oficce: this.selectedSucursalIdstring,
      role: this.selectedDepartmentId_string,
      user: this.selectedPersonId_string,
      client: this.selectedClienteIdstring,
      equipment: this.selectedEquipmentstring,
      category: this.selectedCategoryIdstring,
      subcategory: this.selectedSubCategoryIdstring,
      selectedDate: this.selectedDate,
      startRange: this.startRange,
      endRange: this.endRange,
      orders_by_block: this.orders_by_block,
      pageActual: this.pageActual,
    };
    this.storageService.setFiltersDashboard(filters);

    this.showInfoPoint = false;
    this.showMiniDashboard = true;
    this.spinner.show();
    this.cd.detectChanges();
    // this.isSearching = false;

    Promise.all([
      this.userService.customerDB.app
        .firestore()
        .collection("users_details")
        .get(),
      this.userService.customerDB.app.firestore().collection("modules").get(),
    ]).then(([details, categories]) => {
      this.ordersService.getOrdersApi(filters).subscribe((response: any) => {
        let data = response.data;
        this.totalitems = response.totalitems;

        this.ordenes = [];
        this.ordenes_clone = [];
        let lastOrder: any;

        for (let doc of data) {
          this.categories_all = categories;
          var users_details: any = details.docs
            .map((d) => d.data())
            .find((f) => f.uid == doc.user_uid);
          var category_details: any = categories.docs
            .map((d) => d.data())
            .find((f) => f.category == doc.category);

          let names_array_total = [];
          let photourl = doc.photoUrl ? doc.photoUrl : null;

          if (users_details !== undefined) {
            if (users_details.profile == "ADMINISTRADOR" && photourl == null) {
              photourl =
                "https://firebasestorage.googleapis.com/v0/b/trackpoint-d2fa6.appspot.com/o/avatares%2Fadmin%2Fadmon-azul.svg?alt=media&token=c96f9c81-ab70-4733-89c3-bcc0c47d8a2d";
            } else if (users_details.profile == "CAMPO" && photourl == null) {
              photourl =
                "https://firebasestorage.googleapis.com/v0/b/trackpoint-d2fa6.appspot.com/o/avatares%2Fcampo%2Fcampo-azul.svg?alt=media&token=a422da4d-cb51-442c-8786-8e424b2ad8eb";
            } else if (users_details.profile == "SOPORTE" && photourl == null) {
              photourl =
                "https://firebasestorage.googleapis.com/v0/b/trackpoint-d2fa6.appspot.com/o/avatares%2Fsoporte%2Fsoporte-azul.svg?alt=media&token=9b11c3ca-a030-4c5b-ba14-152baebee147";
            }
          } else {
            photourl =
              "https://firebasestorage.googleapis.com/v0/b/trackpoint-d2fa6.appspot.com/o/avatares%2Fcampo%2Fcampo-azul.svg?alt=media&token=a422da4d-cb51-442c-8786-8e424b2ad8eb";
          }

          let names_array = {
            name: doc.user_name,
            uid: doc.user_uid,
            photo: photourl,
          };
          names_array_total.push(names_array);

          console.log("SPLITTT ", doc);
          if (doc.history_transfer_names) {
            const split_names = doc.history_transfer_names.split(",");
            if (doc.history_transfer_names && split_names.length > 0) {
              for (let item_user_history of split_names) {
                let split_push = item_user_history.split("@|");

                let enter = true;

                for (let item_ of names_array_total) {
                  if (item_.uid == split_push[1]) {
                    enter = false;
                    break;
                  }
                }

                if (enter) {
                  names_array_total.push({
                    name: split_push[0],
                    uid: split_push[1],
                  });
                }
              }
            }
          }

          var pinIrltemp = "";

          doc.authorization_status = doc.authorization_status
            ? parseInt(doc.authorization_status)
            : 0;

          if (
            doc.status == 2 &&
            (doc.authorization_status == undefined ||
              doc.authorization_status === 0 ||
              doc.authorization_status === null)
          ) {
            pinIrltemp =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArxJREFUeNrsWd1twjAQJqjvpRvQDWACkgUKTFAyAc1LX9u+9qV0AugG0AVIJ2g2KJ2AjNBzdZEiyz9n+xx44KQTAjmX73x/n02vd5GLBEkSw+jN6+cQPobSz4fj493hLB0AwAP4mIFOQVPQgWF5CboD3YBD9UkdQOAPoEsLaJ1sQF9CIpMEgBc7vvYE3pYanVh15gCAF8AXzOm8Bc1d0yo5E/CNVKCZixNXEcGX0veU8MwIdA86Zo8AgBfF+kYoyh3s4NZQN1PCJqzARsHmAPb1b0PBitAX8NKSaG+EDWBkWJZR7PWJAXiygM+o4IXA2v9nsHB1smaJAO7+D1fRKex/GyIx16WjSxEvDf17rgIPoBaY6w0wMag+xI4r1me4QaoI31uiRIrAj4LX9HD4PDvm9gGdrhwaxI0pwn0PUtbs/kpBK/aWwhS29mi3XRMrtKmSNKSIdWBUqfBGpBUDTYFuHTEEOfCl2H2X6ZzKUZBttuSao42qcpm8S4Z0MtlkiUBMSTmMnNIB6uCrQhwoieGvGNJwqFn3G+KADthEaoM1EjnySUxxCpv4RKpv4Sy1pr3NsPO0pTAUojxDCs2Zuqe4CKhCa2Cn6eULhbOZJZ103OlBM0O2XHT6KL2gRiCVZn3DhQat9eKcsHGk6re2Az/VgWek1FbwHrcaOvoh6iRnaaNI2g4dgv+/qeCeA4UOvAADmjqATzFtdFP2nXpXlDDvZIkvN52Jl5YpXMHz/Id6jzSoJIpMjdDYJUWvIoH3JXgvrvWVRALvxY0AfNYJmcNBVDOCF7s+75qNzj1JnKpl5r43G6FF3FwFhtxQj0PmStB5oHVB5ZtOeehQ5PqHJsVIuILfhL6b5USG14p51+DZIiCx0HVX4NkdIDjBCj6KAy3OI/9/xg4+mgOKFhsFfHQRTmA0LnKRc5U/AQYApgMx4VyJleUAAAAASUVORK5CYII=";
          } else if (
            doc.status == 3 &&
            (doc.authorization_status === 0 ||
              doc.authorization_status === null)
          ) {
            pinIrltemp =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAr5JREFUeNrsWV1OwkAQpsT4Kt4AX32CE9ieADmB9ATYE6gnEE9AvQGcgHoC+uQreAL77JOzZpo0m/2Z3Z2tPDDJhEC202/+Z5bB4ExnCqIkhtDLz3IMH2Pp5+PP7eJ4kgoA4BF83APPgFPgkeF4BbwFLkGh5l8VQOCPwEsLaB2VwC8hnkkCwAuLrz2Bd6lBJVa9KQDgBfAFczhvgHPXsEpOBHxLNXDmosRFRPCV9D0lPDMB3gFP2T0A4EWyvhKScgsW3BjyZkYwwgpkFGwKYF3fGxJWuL6Al1ZEeRMsABPDsYwib0h0wJMFfEYFLwjO/j2DiaujNYsH0PoHrqRTyN8bPDHXhaNLEi8N9XuuAg+gFhjrLTDRqN6FxRXnMzSQysMPFi+RPHBQzDUDbD7PjrF9RKVrhwJxbfLw0GMoa62/UowVO0tiClk7lNvNiRXKVFEaksQ6MKpQeCWOFSNNgm4cMQQp8KGwvkt3TmUvyDI7dMVRRlWxTLaSIZxMMlk8EJNSDiH/qQC18dUhClRE99cMYTjWnPsKUUAH7E4qgw0OcuRNTLGF3fl4amiZWRpNebvHytOlwpCIcg8pNDv1QHERUIfmwFZTyxcKZTNLOOlmp0dND9lwjdPf0gsaBFJrzrez0KhzXuwJpeOofmNb+KkKPONIbQXvcauhGz9EnuScG1k7MfYBXhhpSrlucekDhQ68AAOcOoBPMWx0XfaNeleUMFuywpebduKlpQvX8Dz/Uu8RBrU0IlM9NHUJ0YtI4H0HvBfX/EoigfeajQB81sswh42oYQQvrD7vexqdew5xqpKZ+95shCZxexUYckM9DekrQftA54LKN5zy0KbI9Q9Nip5wBV+GvptlI8Nrxbxv8GwekKbQdV/g2RUgKMEKPooCnZlH/v+MHXw0BRQlNgr46CSUQG+c6UynSr8CDAAj4zFC+dlQEwAAAABJRU5ErkJggg==";
          } else if (doc.status == 3 && doc.authorization_status === 1) {
            pinIrltemp =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAr5JREFUeNrsWd1NAkEQ5gjvYgfYASQmPnpXgWIDchXgVaBWIFYANmCgAs5HExOuA7ECrwRnzVxy2ezP7O7swQOTTAhkb+6bnb9vl17vJCcJkiSG0c+vuxF8jKSf91eX7/ujdAAAD+HjFvQGNAUdGpaXoBvQFThUH9QBBP4AOreA1skK9DkkMkkAeLHjS0/gbanRiUVnDgB4AXzGnM5r0Nw1rZIjAd9IBZq5ODGICL6UvqeEZ8agW9AJewQAvCjWF0JRbmAH14a6uSFswgJsFGwOYF/fGQpWhL6Al5ZEe2NsAGPDsoxir08MwKMFfEYFLwTW/j+DhauTJUsEcPe/uYpOYX9niMRUl44uRTw39O+pCjyAmmGuN8DEoHoTO65Yn+EGqSJ8b4kSKQLfCl7Tw+Hz5Jjbe3S6cmgQ56YI9z1IWbP7CwWt2FoKU9jaot12TSzQpkrSkCLWgVGlwguRVgw1Bbp2xBDkwIdi912mcypHQbbZkjOONqrKZfIuGdLJZJMlAjEl5TBySAeog68KcaAkhr9iSMORZt1PiAM6YNdSG6yRyJFPYopT2LVPpPoWzlJr2tstdp62FIZClGdIoTlT9xQXAVVoDWw0vXymcDazpJOOOz1oZsiai07/Si+oEUilWd9woWFrvTgnrByp+oXtwE914AkptRW8x62Gjn6IOslZ2iiStn2H4P9vKrjnQKEDL8CApg7gU0wb3ZR9pd4VJcw7WeLLTWfiuWUKV/A8/6HeIw0qiSJTIzRxSdFBJPC+BO/Ztb6SSOC9uBGAzzohcziIakbwYtenXbPRqSeJU7XM3PdmI7SIm6vAkBvqSchcCToPtC6ofNMpDx2KXP/QpBgJV/Cr0HeznMjwWjHvGjxbBCQWuuwKPLsDBCdYwUdxoMV55P/P2MFHc0DRYqOAjy7CCYzGSU5yrPInwAC1wS2rPcCKbgAAAABJRU5ErkJggg==";
          } else if (doc.status == 3 && doc.authorization_status === 2) {
            pinIrltemp =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAr1JREFUeNrsWd1twjAQJqjvpRvQASrBBCQvfQUmKJmAZoK2E5ROAN0AXvtCOkEjdYDSCZoRekYXKbL8c7bPgQdOOkEr5/Kd7++z6fUucpEgSWIYnX58D+FjKP37sLu/O5ylAwB4AB8z8RU0BR0YlpegO9ANOFSf1AEE/gi6tIDWyQb0JSQySQB4seNrT+BtqdGJVWcOAHgBfMGczlvQ3DWtkjMB30gFmrk4cRURfCn9nRKeGYHuQcfsEQDwolhfCUW5gx3cGupmStiEFdgo2BzAvv5lKFgR+gJeWhLtjbABjAzLMoq9PjEATxbwGRW8EFh7fAYLVydrlgjg7v9wFZ3C/pchEnNdOroU8dLQv+cq8ABqgbneABOD6l3suGJ9hhukivCDJUqkCPwoeE0Ph8+zY24f0OnKoUHcmCLc9yBlze6vFLRibylMYWuPdts1sUKbKklDilgHRpUKr0RaMdAU6NYRQ5ADn4rdd5nOqRwF2WZLrjnaqCqXybtkSCeTTZYIxJSUw8gpHaAOvirEgZIY/oohDYeadb8hDuiATaQ2WCORI5/EFKewiU+k+hbOUmva2ww7T1sKQyHKM6TQnKl7iouAKrQGdppevlA4m1nSScedHjUzZMtFp/+kF9QIpNKsb7jQoLVenBM2jlT91nbgpzrwjJTaCt7jVkNHP0Sd5CxtFEnboUPwx5sK7jlQ6MALMKCpA/gU00Y3Zd+od0UJ806W+HLTmXhpmcIVPM9/qPdIg0qiyNQIjV1S9CoSeF+C9+JaX0kk8F7cCMBnnZA5HEQ1I3ix6/Ou2ejck8SpWmbue7MRWsTNVWDIDfU4ZK4EnQdaF1S+6ZSHDkWuX2hSjIQr+E3ou1lOZHitmHcNni0CEgtddwWe3QGCE6zgozjQ4jzy72fs4KM5oGixUcBHF+EERuMiFzlX+RdgAJZiLfiDmOB6AAAAAElFTkSuQmCC";
          } else if (doc.status == 2 && doc.authorization_status === 3) {
            pinIrltemp =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArlJREFUeNrsWettwjAQJqj/SzegG0AXIJmAZoKSCWgmaJmgdALoBIUJSBdos0HpBM0IPVcXKbL8ONvnwA9OOiGQc/nO9/psBoOLXCRIkhhGP/N8DB9j6efj3fv78SwdAMAj+LgHnYOmoCPD8gp0D7oFh5qTOoDAH0GXFtA62YKuQiKTBIAXO77xBN6VBp1Y9+YAgBfAF8zpvAMtXNMqORPwrdSgmYsTVxHBV9L3lPDMBPQAOmWPAIAXxfpCKMo97ODOUDdzwiaswUbJ5gD29S9DwYrQl/DSimhvgg1gYliWUewNiQF4soDPqOCFwNr/Z7BwdbJhiQDu/jdX0SnsfxkikevS0aWIl4b+navAA6gF5noLTAyqN7HjivUZbpAqwg+WKJEi8K3gNQMcPs+OuX1Ep2uHBnFjivDQg5S1u79W0IqDpTCFrQPa7dbEGm2qJA0pYh0YVSq8EGnFSFOgO0cMQQ58KHbfZTqnchRkmx255mijqlwm75IhnUw2WSIQU1IOI6d0gDr46hAHKmL4a4Y0HGvW/YQ4oAM2k9pgg0SOfBJTnMJmPpEaWjhLo2lv99h5ulIaClGeIaXmTD1QXATUoTWw1/TyhcLZzJJOOu70qJkhOy46/Su9oEEgtWZ9y4VGnfXinLB1pOq3tgM/1YFnpNRW8B63Gjr6IeqkYGmjSNqOPYL/v6ngngOlDrwAA5o6gE8xbXRT9pV6V5Qw72SFLzediZeWKVzD8/yHeo80qCWKTI3Q1CVFryKB9yV4K9f6SiKB9+JGAD7rhczhIGoYwYtdz/tmo7kniVO1zML3ZiO0iNurwJAb6mnIXAk6D3QuqHzTqQgdilz/0KQYCVfw29B3s5zI8Fqx6Bs8WwQkFrrpCzy7AwQnWMFHcaDDeeT/z9jBR3NA0WKjgI8uwgmMxkUucq7yJ8AAXbUw7OIPFUMAAAAASUVORK5CYII=";
          } else if (doc.status == 5) {
            pinIrltemp =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArpJREFUeNrsWd1twjAQJqjvpRvQDWCCJk99BCYomYBmgpYJoBNAN4DHPpFO0GwAnYCM0HN1kSLLP2f7HHjgpBMCOZfvfH+fTa93k5sESRLD6Pl5MYSPofTz6eHr43SVDgDgAXxMQSegKejAsLwE3YNuwaH6og4g8FfQhQW0Tragy5DIJAHgxY5vPIG3pUYn1p05AOAF8DlzOu9Ac9e0Sq4EfCMVaObixF1E8KX0PSU8MwI9gI7ZIwDgRbGuCEW5hx3cGepmQtiENdgo2BzAvv5jKFgR+gJeWhLtjbABjAzLMoq9PjEAbxbwGRW8EFj7/wwWrk42LBHA3T9yFZ3C/o8hEjNdOroU8cLQv2cq8ABqjrneABOD6lPsuGJ9hhukivCLJUqkCBwVvKaHw+fdMbdP6HTl0CAeTBHue5CyZvfXClpxsBSmsHVAu+2aWKNNlaQhRawDo0qFFZFWDDQFunPEEOTAt2L3XaZzKkdBttmSe442qspl8i4Z0slkkyUCMSXlMHJJB6iDrwpxoCSGv2JIw6Fm3W+IAzpgT1IbrJHIkU9iilPYk0+k+hbOUmva2xQ7T1sKQyHKM6TQnKl7iouAKrQG9ppePlc4m1nSScedXjUzZMdFp8/SC2oEUmnWN1xo0FovzglbR6r+aDvwUx14R0ptBe9xq6GjH6JOcpY2iqTt1CH4/5sK7jlQ6MALMKCpA/gU00Y3ZT+od0UJ806W+HLTmXhhmcIVPM9/qPdIg0qiyNQIjV1S9C4SeF+Ct3StryQSeC9uBOCzTsgcDqKaEbzY9VnXbHTmSeJULTP3vdkILeLmKjDkhnocMleCzgOtCyrfdMpDhyLXPzQpRsIV/Db03SwnMrxWzLsGzxYBiYVuugLP7gDBCVbwURxocR75/zN28NEcULTYKOCji3ACo3GTm1yr/AkwANALL3l86KDUAAAAAElFTkSuQmCC";
          } else if (doc.status == 4) {
            pinIrltemp =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAuJJREFUeNrsWTtuGzEQXckCks6bCxhK4zqqU3i3SxHA1gkinUDeE8Q+geUTSLmBBKTXpgiQzkzrxjJ8gGzrwkCGwSyw2HDIITkrq9AAA8MCNXzz4zxSSXKQg0RJrwujbz5+HsKfYevj7fPP79u9dAAAp/DnAvQcNANNLctL0DXoEhyqXtUBBH4JOnOApmQJeh2TmaMI8DriG9BPoG8DzXwAnQxOTp9fnu5/7SwDAH6hNxYu5xXo1LesensCvhYFmvs4MegQfNn6P2OWlC7LkXgGALxu1htGU64hgitL35wzgjAHG4WYA3iu31lOGp36AjYtmfZ0pBcYcUpyjr0+MwFfHeBzLngtsPbfd7BxKVmIZACj/yDVdAb7d5ZMjKly9GniGfF5hRtUBlATrPUamB5U33TEDetzDJApw18cWWJl4MHAaxKcoFeetb1Fp5XHAfHOluF+ACmroz830IqNozG1rQ3abfbEHG2aJItpYgqMqRRumHwoJRp05YkhyoEfhuj7TOesnYW2zYYcSxyjplpmR8lSTjabIhnoUjIJI6/pAHfwqRgHSmb6lUAZDol1jzEOUMDOWsdghUSOfRMz3MLOQjLVd3CWijjeLvDkaUphacT2DCmIO3VieAhQsT2wJs7yicHZ3FFOFHe6JGbISopO/2ltUCEQRayvuVDaWK/vCUtPqv7edeHnOnCFlNoJPuBVg6Ifuk+mkjeymjHuArwO0ojz3OIzBwoKvAYDmnmAz7BsqCl7y30r6glHssTNbXfimWMKK/i+/KU+oAxUiyJzMzTyKdFBR+BDCd61b3/1OgIfxI0AfL4TMoeDqBIEr6M+3jUbHQeSONOROQ192Yht4vopMI0wM4qZK1H3gcYDVWg5TWOHotQvNBlmwhf8MnbvIwkHXp7ut4OT00eCEncGXswBdEIxnRADL+oA0wlR8OIONJz4nfz/25k4eLEmZhyxnYDvXLQTyEAPcpB9lb8CDACtO0PxAuS8dAAAAABJRU5ErkJggg==";
          }

          let stardate: any = doc.start_date;
          let enddate: any = doc.end_date;

          this.ordenes.push({
            id: doc.id,
            order_number: doc.order_number,
            customer_uid: doc.customer,
            customer_name: doc.customer_name,
            order_name: doc.order_name,
            address: doc.address,
            users_all: doc.users_all,
            start_date: stardate.value.replace("T", " "),
            end_date: enddate != null ? enddate.value.replace("T", " ") : "",
            latitude: doc.latitude,
            longitude: doc.longitude,
            users: doc.users,
            status: doc.status.toString(), //1 -> pendiente, 2 -> proceso, 3 -> completado
            authorization_status: doc.authorization_status, // 1-> Pendiente, 2 -> Aceptado, 3 -> Rechazado
            user_uid: doc.user_uid,
            departamento: doc.departamento,
            sucursal: doc.sucursal,
            user_name: doc.user_name,
            geolocation: null,
            address_checkIn: doc.address_checkIn,
            category: doc.category,
            tipo: doc.tipo,
            qr_equipment: doc.qr_equipment,
            scheduled_equipment_uid: doc.scheduled_equipment_uid,
            evidence: [],
            evidence_first_id: "",
            description_photo_evidence: "",
            photo_evidence: [],
            classification_category_uid: doc.classification_category_uid
              ? doc.classification_category_uid
              : "",
            classification_subcategory_uid: doc.classification_subcategory_uid
              ? doc.classification_subcategory_uid
              : "",
            classification_category_name: doc.classification_category_name
              ? doc.classification_category_name
              : "",
            classification_subcategory_name: doc.classification_subcategory_name
              ? doc.classification_subcategory_name
              : "",

            is_utc: doc.is_utc,
            start_date_utc:
              doc.is_utc && doc.start_date_utc
                ? this.timezoneConversionService.getTimeConvertedTimeZone(
                    doc.start_date_utc.toDate(),
                    this.currentTimeZone.reference
                  ).formatDashboard
                : "",
            end_date_utc:
              doc.is_utc && doc.end_date_utc
                ? this.timezoneConversionService.getTimeConvertedTimeZone(
                    doc.data().end_date_utc.toDate(),
                    this.currentTimeZone.reference
                  ).formatDashboard
                : "",

            history_transfer_names: doc.history_transfer_names
              ? doc.history_transfer_names
              : [],
            history_transfer_names_array: names_array_total,
            pinUrl: pinIrltemp,
            dynamic_url_web: doc.dynamic_url_web,
          });

          // this.ordenes.push({
          //   id: doc.id,
          //   order_number: doc.order_number.toString(),
          //   customer_name: doc.customer_name,
          //   order_name: doc.order_name,
          //   address: doc.address,
          //   users_all: doc.users_all,
          //   start_date: stardate.value.replace('T', ' '),
          //   end_date: enddate != null ? enddate.value.replace('T', ' ') : "",
          //   latitude: doc.latitude,
          //   longitude: doc.longitude,
          //   users: doc.users,
          //   status: doc.status.toString(), //1 -> pendiente, 2 -> proceso, 3 -> completado
          //   user_uid: doc.user_uid,
          //   departamento: users_details && users_details.departamento,
          //   sucursal: users_details && users_details.sucursal,
          //   user_name: doc.user_name,
          //   geolocation: doc.geolocation,
          //   address_checkIn: doc.address_checkIn,
          //   category: doc.category,
          //   tipo: (category_details && category_details.name) ? category_details && category_details.name : '',
          //   evidence: [],
          //   evidence_first_id: '',
          //   description_photo_evidence: '',
          //   photo_evidence: [],
          //   classification_category_name: doc.classification_category_name,
          //   classification_subcategory_name: doc.classification_subcategory_name,
          //   is_utc: doc.is_utc,
          //   start_date_utc: doc.is_utc && doc.start_date_utc ? this.timezoneConversionService.getTimeConvertedTimeZone( doc.start_date_utc.toDate(), this.currentTimeZone.reference).formatDashboard : '',
          //   end_date_utc: doc.is_utc && doc.end_date_utc ? this.timezoneConversionService.getTimeConvertedTimeZone(doc.end_date_utc.toDate(), this.currentTimeZone.reference).formatDashboard : '',
          //   authorization_status: doc.authorization_status.toString() ? doc.authorization_status : null,
          //   history_transfer_names: doc.history_transfer_names ? doc.history_transfer_names : [],
          //   history_transfer_names_array: names_array_total,
          //   pinUrl: pinIrltemp,
          //   dynamic_url_web: doc.dynamic_url_web
          // });

          this.ordenes_clone = this.ordenes;

          lastOrder = {
            latitude: doc.latitude,
            longitude: doc.longitude,
          };
        }

        console.log("~ this.user_selected", this.user_selected);

        console.log("~ this.isSearching", this.isSearching);
        console.log("~ this.selectedPersonId", this.selectedPersonId);
        console.log("~ this.selectedSucursalId", this.selectedSucursalId);
        console.log("~ this.selectedTipoId", this.selectedTipoId);
        console.log("~ this.selectedClienteId", this.selectedClienteId);
        console.log("~ this.selectedEquipmentId", this.selectedEquipmentId);
        console.log("~ this.selectedCategoryId", this.selectedCategoryId);
        console.log("~ this.selectedSubcategoryId", this.selectedSubcategoryId);
        console.log("~ this.ordenes", this.ordenes);

        this.filterOrdenesAll(this.ordenes);
        /*if (this.user_selected) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.filterOrdenes(f, this.user_selected);
            });
          }*/

        /*if (
            this.isSearching &&
            this.selectedPersonId &&
            this.selectedPersonId.length > 0
          ) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.selectedPersonId.includes(f.user_name);
            });
          }
          if (
            this.isSearching &&
            this.selectedDepartmentId &&
            this.selectedDepartmentId.length > 0
          ) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.selectedDepartmentId.includes(f.departamento);
            });
          }
          if (
            this.isSearching &&
            this.selectedSucursalId &&
            this.selectedSucursalId.length > 0
          ) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.selectedSucursalId.includes(f.sucursal);
            });
          }
           if (
            this.isSearching &&
            this.selectedTipoId &&
            this.selectedTipoId.length > 0
          ) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.selectedTipoId.includes(f.tipo);
            });
          }
         if (
            this.isSearching &&
            this.selectedClienteId &&
            this.selectedClienteId.length > 0
          ) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.selectedClienteId.includes(f.customer_name);
            });
          }
          if (
            this.isSearching &&
            this.selectedCategoryId &&
            this.selectedCategoryId.length > 0
          ) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.selectedCategoryId.includes(f.classification_category_name);
            });
          }
          if (
            this.isSearching &&
            this.selectedSubcategoryId &&
            this.selectedSubcategoryId.length > 0
          ) {
            this.ordenes = this.ordenes.filter((f: ordenesObj) => {
              return this.selectedSubcategoryId.includes(f.classification_subcategory_name);
            });
          }*/
        this.ordenes$ = this.getOrdenes();

        this.ordenesForDashboard = this.ordenespin.slice(0);
        // console.log("estas son las ordenes jeje");
        // console.log(this.ordenes);
        // console.log(this.ordenes.slice(0));
        this.spinner.hide();
        this.cd.detectChanges();
        this.refresh().then(() => {
          let inBoundsEventsWEndDate = this.MarkersVisible.filter(
            (f) => f.end_date
          ).slice(0);

          this._totalMarksVisible = this.MarkersVisible.length;
          this._totalPromDuracion =
            inBoundsEventsWEndDate.reduce(
              (t1, t) =>
                (t1 += Moment(t.end_date).diff(
                  Moment(t.start_date),
                  "seconds"
                )),
              0
            ) / this.MarkersVisible.filter((f) => f.end_date).length;
          /*console.log('Duración: ', inBoundsEventsWEndDate.reduce(
              (t1, t) =>
                (t1 += Moment(t.end_date).diff(
                  Moment(t.start_date),
                  'seconds'
                )),
              0
            ) + ' / ' + this.MarkersVisible.filter((f) => f.end_date).length + ' = ' + this._totalPromDuracion);*/
          this._totalPromDistance =
            this.MarkersVisible.reduce(
              (t, t1, t2, t3) =>
                (t += t3[t2 + 1]
                  ? this.utilsService.distance(
                      t1.latitude,
                      t1.longitude,
                      t3[t2 + 1].latitude,
                      t3[t2 + 1].longitude,
                      "K"
                    )
                  : 0),
              0
            ) /
            (this.MarkersVisible.length - 1);

          /*this.users = this.MarkersVisible.map((u) =>
              Object({ id: u.user_uid, text: u.user_name })
            ).filter(
              (value, index, self) =>
                self.findIndex((f) => f.text == value.text) === index
            );*/

          //this.users = this.user_list;

          /*
            this.departamentos = this.MarkersVisible.map((u) =>
              Object({ id: u.departamento, text: u.departamento })
            ).filter(
              (value, index, self) =>
                self.findIndex((f) => f.text == value.text) === index
            );*/
          //this.departamentos = this.department_list ;

          /*this.sucursales = this.MarkersVisible.map((u) =>
              Object({ id: u.sucursal, text: u.sucursal })
            ).filter(
              (value, index, self) =>
                self.findIndex((f) => f.text == value.text) === index
            );*/
          //this.sucursales = this.office_list;

          /*
            this.tipos = this.MarkersVisible.map((u) =>
              Object({ id: u.category, text: u.tipo })
            ).filter(
              (value, index, self) =>
                self.findIndex((f) => f.text == value.text) === index
            );*/

          //this.tipos = this.events_list;

          /* this.clientes = this.MarkersVisible.map((u) =>
              Object({ id: u.customer_uid, text: u.customer_name == null ? '' : u.customer_name })
            ).filter(
              (value, index, self) =>
                self.findIndex((f) => f.text == value.text) === index
            );*/

          //this.clientes = this.customersList;

          /*
            this.categories = this.MarkersVisible.map((u) =>
              Object({ id: u.classification_category_uid, text: u.classification_category_name == null ? '' : u.classification_category_name })
            ).filter(
              (value, index, self) =>
                self.findIndex((f) => f.text == value.text) === index
            );
  
            this.subcategories = this.MarkersVisible.map((u) =>
              Object({ id: u.classification_subcategory_uid, text: u.classification_subcategory_name == null ? '' : u.classification_subcategory_name })
            ).filter(
              (value, index, self) =>
                self.findIndex((f) => f.text == value.text) === index
            );*/
          //this.categories = this.categories_list;
          /*if(this.selectedCategoryIdstring == "")
              this.subcategories = [];*/
        });

        this.loadImageEvidenceByBlock();
      });
    });
  }

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen != null) {
    }

    gm.lastOpen = infoWindow;

    infoWindow.open();
  }

  setRange($event) {
    this.order_pin_selected.id = null;
    const myMoment: moment.Moment = $event.start;
    const myMoment2: moment.Moment = $event.end;
    this.startRange = formatDate(myMoment.toString(), "yyyy-MM-dd", "en");
    this.endRange = formatDate(myMoment2.toString(), "yyyy-MM-dd", "en");
    this.originalStartRange = this.startRange;
    this.originalEndRange = this.endRange;
    this.startRange = formatDate(
      this.timezoneConversionService.timezoneClientOffset(
        this.startRange + " 00:00:00",
        this.currentTimeZone.reference
      ),
      "yyyy-MM-dd HH:mm:ss",
      "en"
    );
    this.endRange = formatDate(
      this.timezoneConversionService.timezoneClientOffset(
        this.endRange + " 23:59:59",
        this.currentTimeZone.reference
      ),
      "yyyy-MM-dd HH:mm:ss",
      "en"
    );
    this.isSearching = true;
    console.log("1111111111111 6");

    this.Period();
  }

  setEvidences(orders: ordenesObj[]) {
    this.ordenes = [];
    this.ordenes_clone = [];
    this.ordenes = orders;
    this.ordenes_clone = this.ordenes;

    for (let obj of this.ordenes) {
      var firebase_id = obj.id;
      var evidence: ItemEvent[] = [];
      obj.evidence = evidence;
      obj.evidence_first_id = "";
      obj.photo_evidence = [];
      obj.description_photo_evidence = "";

      this.userService.customerDB.app
        .firestore()
        .collection("orders")
        .doc(firebase_id)
        .collection("evidence")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc: any) => {
            obj.evidence.push({
              id: doc.data().id,
              title: doc.data().title,
              description: doc.data().description,
              photos: doc.data().photos,
              last_signed_name: doc.data().last_signed_name,
              last_signed_customer_name: doc.data().last_signed_customer_name,
              signatures: doc.data().signatures,
              questions: doc.data().questions,
              itemId_assigned: doc.data().itemId_assigned,
              maps: doc.data().maps,
            });

            if (doc.data().photos.length > 0) {
              obj.description_photo_evidence = doc.data().description;
              obj.photo_evidence = doc.data().photos;
              obj.evidence_first_id = doc.data().id;
            }
          });

          console.log("NEW ORDER -> " + obj.id);
          //this.loadUrlPhotos(obj);
        })
        .catch((err) => {
          console.log("Error Firebae -> " + err);
        });
    }
  }

  loadUrlPhotos(order: ordenesObj) {
    if (order.photo_evidence.length > 0) {
      var contador = 0;
      for (let photo of order.photo_evidence) {
        //this.userService.customerSelected = this.authService.customerSelected;

        this.userService.customerDB.app
          .storage()
          .ref(
            order.user_uid +
              "/orders/" +
              order.id +
              "/evidence/" +
              order.evidence_first_id +
              "/"
          )
          .child(photo.photo_name)
          .getDownloadURL()
          .then((URL) => {
            //console.log('URL: ' + URL);
            photo.url_photo = URL;
            contador = contador + 1;

            if (contador == order.photo_evidence.length) {
              let start_date = Moment(this.order_pin_selected.start_date);
              let end_date = Moment(this.order_pin_selected.end_date);
              /**/
              this.title = this.order_pin_selected.order_name;
              this.in = start_date.isValid()
                ? start_date.format("D MMM Y hh:mm a")
                : "";
              this.out = end_date.isValid()
                ? end_date.format("D MMM Y hh:mm a")
                : "";
              this.address = this.order_pin_selected.address_checkIn;
              this.user = this.order_pin_selected.user_name;
              this.description =
                this.order_pin_selected.description_photo_evidence;
              this.photo_evidence = this.order_pin_selected.photo_evidence;
            }
          })
          .catch((err) => {
            console.log("Error al obtener foto url: " + err);
          });
      }
    }
  }

  Detail() {
    console.log("Order Pin -> " + JSON.stringify(this.order_pin_selected));
    if (this.authService.customer_route != "") {
      const ruta = "/" + this.authService.customer_route + "/detail-order";
      const url = this.router.serializeUrl(
        this.router.createUrlTree([ruta], {
          queryParams: {
            //order_uui: btoa(this.order_pin_selected.id)
            order_uui: this.order_pin_selected.id,
          },
        })
      );

      window.open(url, "_blank");
    }
  }

  DetailGo(order: ordenesObj) {
    console.log("Order Info", order);
    let dataDetailUser = this.storageService.getDetailDataCurrentUser();
    if (dataDetailUser) {
      dataDetailUser = JSON.parse(dataDetailUser);
      const uidUser = dataDetailUser["uid"];
      let urlEvento = "";

      if (
        order.authorization_status !== null &&
        (order.authorization_status == 1 || order.authorization_status == 2)
      ) {
        urlEvento =
          this.authService.customerSelected.url_report +
          order.id +
          "&authorizer=" +
          encodeURIComponent(
            this.encryptDecryptService.encryptRerturnSimpleString(uidUser)
          );
      } else {
        if (this.storageService.getCurrentDB() != "") {
          urlEvento = this.authService.customerSelected.url_report + order.id;
        }
      }
      window.open(urlEvento, "blank");
    }
  }

  salir() {
    this.authService
      .doLogout()
      .then(() => {
        if (this.storageService.getCurrentDB() != "") {
          const ruta = "/" + this.storageService.getCurrentDB() + "/login";
          this.storageService.logout();
          this.router.navigate([ruta]);
        }
      })
      .catch((err) => {
        // console.error('Error LogOut -> ' + err);
        if (this.storageService.getCurrentDB() != "") {
          const ruta = "/" + this.storageService.getCurrentDB() + "/login";
          this.storageService.logout();
          this.router.navigate([ruta]);
        }
      });
  }

  /***************************/
  getOrdenes(): Observable<ordenesObj[]> {
    return this.ordenesSubject.asObservable();
  }

  private refresh() {
    return new Promise((resolve) => {
      this.ordenesSubject.next(this.ordenes);
      setTimeout(resolve, (this.ordenes.length * 5000) / 900, true);
    });
  }

  async pageChanged($event) {
    // AQUI ES AL CAMBIA PAGINA
    console.log("pageActual BEF: ", $event);

    this.pageActual = $event;
    this.spinner.show();
    this.cd.detectChanges();
    console.log("1111111111111 7 ");

    await this.Period();
    console.log("pageActual: ", this.pageActual);
  }

  orders_by_blockChanged() {
    this.pageActual = 1;
    console.log("1111111111111 8 ");
    this.Period();
  }

  refreshMarkets() {
    // AQUI ES DESPUES DE CAMBIAR
    console.log("refreshMarkets BEF: ");
    var start_index =
      this.orders_by_block * this.pageActual - this.orders_by_block;
    var end_index = Number(start_index) + Number(this.orders_by_block - 1);
    this.ordenespin = [];
    this.ordenesForDashboard = [];
    for (let i = 0; i < this.ordenes.length; i++) {
      this.ordenespin.push(this.ordenes[i]);
    }
    this.ordenesForDashboard = this.ordenespin.slice(0);
    console.log("start index");
    console.log(start_index);
    console.log("end index");
    console.log(end_index);
    console.log("ordenespin deberian de ser las 12");
    console.log(this.ordenespin);
    console.log("ordenes para dashboard");
    console.log(this.ordenesForDashboard);
    this.checkMarkersInBounds(this.bounds);
  }

  loadEvidenceFirstBlock() {
    var start_index =
      this.orders_by_block * this.pageActual - this.orders_by_block;
    console.log(start_index);
  }

  loadImageEvidenceByBlock() {
    //if(this.pageActual > 1){
    var start_index =
      this.orders_by_block * this.pageActual - this.orders_by_block;
    var end_index = start_index + this.orders_by_block - 1;
    this.refreshMarkets();

    for (let i = 0; i < this.ordenes.length; i++) {
      // this.ordenespin.push(this.ordenes[i]);
      // this.ordenesForDashboard = this.ordenespin.slice(0);
      if (this.ordenes[i].evidence.length == 0) {
        //Descargar evidencia//
        //this.userService.customerSelected = this.authService.customerSelected;
        //this.userService.customerDB.app
        //.firestore()
        this.userService
          .getTenancyParams()
          .collection("orders")
          .doc(this.ordenes[i].id)
          .collection("evidence")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc: any) => {
              this.ordenes[i].evidence.push({
                id: doc.data().id,
                title: doc.data().title,
                description: doc.data().description,
                photos: doc.data().photos,
                last_signed_name: doc.data().last_signed_name,
                last_signed_customer_name: doc.data().last_signed_customer_name,
                signatures: doc.data().signatures,
                questions: doc.data().questions,
                itemId_assigned: doc.data().itemId_assigned,
                maps: doc.data().maps,
              });

              if (doc.data().photos.length > 0) {
                this.ordenes[i].description_photo_evidence =
                  doc.data().description;
                this.ordenes[i].photo_evidence = doc.data().photos;
                this.ordenes[i].evidence_first_id = doc.data().id;
              }
            });

            //console.log('NEW ORDER -> ' + obj.id);
            this.loadUrlPhotos(this.ordenes[i]);
          })
          .catch((err) => {
            console.log("Error Firebae -> " + err);
          });
      }
    }
    //}
  }

  downloadPdf(order: ordenesObj) {
    console.log("Descargar pdf -> " + order.id);

    this.order_pdf = order;
    this.url_link =
      "http://trackpoint.dev.webpoint.com.mx/" +
      this.authService.customer_route +
      "/detail-order?order_uui=" +
      this.order_pdf.id;
    //this.url_link = 'http://trackpoint.mx/' + this.authService.customer_route + '/detail-order?order_uui=' + this.order_pdf.id;

    this.url_map =
      "https://maps.googleapis.com/maps/api/staticmap?center=" +
      this.order_pdf.latitude +
      "," +
      this.order_pdf.longitude +
      "&zoom=18&size=600x400&maptype=roadmap&markers=color:green|label:Site|" +
      this.order_pdf.latitude +
      "," +
      this.order_pdf.longitude +
      "&key=AIzaSyDw4PN72JS0z_pPNNofyHvMdlIDEveb63Q";
    //console.log('MAPA -> ' + this.url_map);
    //this.makeMultiPage();
    var element = document.getElementById("content");
    var options = {
      filename: "test.pdf",
    };
    domToPdf(element, options, function () {
      console.log("content");
    });
  }

  makeMultiPage() {
    var quotes = document.getElementById("content");
    html2canvas(quotes).then((canvas) => {
      //! MAKE YOUR PDF
      var pdf = new jspdf("p", "pt", "letter");

      for (var i = 0; i <= quotes.clientHeight / 980; i++) {
        //! This is all just html2canvas stuff
        var srcImg = canvas;
        var sX = 0;
        var sY = 980 * i; // start 980 pixels down for every new page
        var sWidth = 900;
        var sHeight = 980;
        var dX = 0;
        var dY = 0;
        var dWidth = 900;
        var dHeight = 980;

        let onePageCanvas = document.createElement("canvas");
        onePageCanvas.setAttribute("width", "900");
        onePageCanvas.setAttribute("height", "980");
        var ctx = onePageCanvas.getContext("2d");
        // details on this usage of this function:
        // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
        ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

        // document.body.appendChild(canvas);
        var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

        var width = onePageCanvas.width;
        var height = onePageCanvas.clientHeight;

        //! If we're on anything other than the first page,
        // add another page
        if (i > 0) {
          pdf.addPage(612, 791); //8.5" x 11" in pts (in*72)
        }
        //! now we declare that we're working on that page
        pdf.setPage(i + 1);
        //! now we add content to that page!
        pdf.addImage(canvasDataURL, "PNG", 20, 40, width * 0.62, height * 0.62);
      }
      //! after the for loop is finished running, we save the pdf.
      pdf.save("Test.pdf");
    });
  }

  testPdf(order: ordenesObj) {
    this.getBase64ImageFromURL(
      "https://images.pexels.com/photos/209640/pexels-photo-209640.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=300"
    ).then((dataURL) => {
      let logo_b64 = dataURL;
      this.capturedImage = logo_b64;
      //const documentDefinition = this.getDocumentDefinition(logo_b64);
      //pdfMake.createPdf(documentDefinition).download();
    });
  }

  async getDocumentDefinition(logo) {
    return {
      content: [
        {
          text: "PDF Generated with Image from external URL",
          fontSize: 20,
        },
        {
          image: logo,
        },
      ],
    };
  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      const img: any = document.getElementById("img"); //HTML Image Element
      //img.setAttribute("crossOrigin", "anonymous");
      img.crossOrigin = "anonymous";
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = url;
    });
  }

  async getLogoImage() {
    return {
      image: await this.getBase64ImageFromURL(
        "https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Flogo.svg?alt=media&token=bf283e6d-29fd-437f-a156-ff6a7acc09f4"
      ),
      width: 75,
      alignment: "right",
    };
  }

  /******************************************************************************************************/

  goToPdf(order: ordenesObj) {
    this.list_photos = [];
    this.list_signatures = [];
    this.array_questionaries = [];
    this.array_comments = [];
    this.array_evidence = [];
    //this.url_logo_client = '';
    //this.userService.customerSelected = this.authService.customerSelected;
    this.userService.getInfoOrder(order.id).then((order_data: any) => {
      if (order_data != null) {
        this.order_pdf.id = order_data.firebase_id;
        this.order_pdf.order_number = order_data.order_number;
        this.order_pdf.customer_name = order_data.customer_name;
        this.order_pdf.order_name = order_data.order_name;
        this.order_pdf.address = order_data.address;
        this.order_pdf.users_all = order_data.users_all;
        this.order_pdf.start_date = order_data.start_date;
        this.order_pdf.end_date = order_data.end_date;
        this.order_pdf.latitude = order_data.latitude;
        this.order_pdf.longitude = order_data.longitude;
        this.order_pdf.users = order_data.users;
        this.order_pdf.status = order_data.status;
        this.order_pdf.user_uid = order_data.user_uid;
        this.order_pdf.user_name = order_data.user_name;
        this.order_pdf.geolocation = order_data.geolocation;
        this.order_pdf.address_checkIn = order_data.address_checkIn;

        this.url_map =
          '<img src= "https://maps.googleapis.com/maps/api/staticmap?center=' +
          this.order_pdf.latitude +
          "," +
          this.order_pdf.longitude +
          "&amp;zoom=18&amp;size=400x400&amp;maptype=roadmap&amp;markers=color:green|label:Site|" +
          this.order_pdf.latitude +
          "," +
          this.order_pdf.longitude +
          "&amp;key=AIzaSyDw4PN72JS0z_pPNNofyHvMdlIDEveb63Q" +
          '">';
        this.url_link =
          "http://trackpoint.dev.webpoint.com.mx/" +
          this.authService.customer_route +
          "/detail-order?order_uui=" +
          this.order_pdf.id;
        var url_customer = this.authService.customerSelected.url_pdf;
        const link = document.createElement("a");
        link.target = "_blank";
        var url_full = url_customer + this.order_pdf.id;
        console.log(url_full);
        link.href = url_full;
        link.setAttribute("visibility", "hidden");
        link.click();
      } else {
        console.log("No se encontro la orden.");
      }
    });
  }

  loadEvidenOrder() {
    this.userService
      .getAllEvidenceByOrder(this.order_pdf.id)
      .then((evidencia: ItemEvent[]) => {
        if (evidencia.length > 0) {
          this.order_pdf.evidence = evidencia;
          //this.userService.customerSelected = this.authService.customerSelected;
          this.userService
            .getItemsConfiguration()
            .then(() => {
              this.userService
                .getExtraItemsConfig(this.order_pdf.id)
                .then((extra_items: itemsExtra) => {
                  var items_rows_temp_1: itemsConfigDetails[] = [];
                  var items_rows_temp_2: itemsConfigDetails[] = [];

                  for (let obj1 of this.userService.items_config.rows) {
                    items_rows_temp_1.push({
                      id: obj1.id,
                      title: obj1.title,
                      nextScreen: obj1.nextScreen,
                      url_icon: obj1.url_icon,
                      questionary_id: obj1.questionary_id,
                      isExtraItem: false,
                      isDeleted: false,
                    });
                  }

                  for (let obj2 of extra_items.items_extra) {
                    items_rows_temp_2.push({
                      id: obj2.id,
                      title: obj2.title,
                      nextScreen: obj2.nextScreen,
                      url_icon: obj2.url_icon,
                      questionary_id: obj2.questionary_id,
                      isExtraItem: obj2.isExtraItem,
                      isDeleted: obj2.isDeleted,
                    });
                  }

                  /////////Descartar los items default, si se encuentran en los extra///////////////
                  for (let item_df of items_rows_temp_1) {
                    var obj = items_rows_temp_2.find(
                      (item) => item.id === item_df.id
                    );
                    if (obj == null) {
                      items_rows_temp_2.push(item_df);
                    }
                  }

                  this.items_config = items_rows_temp_2;
                  this.items_config = this.items_config.sort(
                    (n1, n2) => n1.id - n2.id
                  );
                  //////////////////////////////////////////////////////////////////////////////////

                  this.getAllUrlPhotosByOrder()
                    .then((res) => {
                      if (res) {
                        for (let item of this.order_pdf.evidence) {
                          console.log(
                            "ITEM EVIDENCE -> " + JSON.stringify(item)
                          );
                          if (item.photos.length > 0) {
                            if (item.itemId_assigned != undefined) {
                              if (item.itemId_assigned == 0) {
                                var photos: Photos[] = [];
                                for (let obj of this.list_photos) {
                                  if (item.id == obj.item_evidence_id) {
                                    photos.push({
                                      photo_name: obj.photo_name,
                                      thumb_name: obj.thumb_name,
                                      url_photo: obj.url_photo,
                                      url_thumb: obj.url_thumb,
                                    });
                                  }
                                }

                                this.array_evidence.push({
                                  id: item.id,
                                  title: "Foto Evidencia",
                                  descripcion: item.description,
                                  evidencia: photos,
                                });
                              } else {
                                for (let obj of this.items_config) {
                                  if (item.itemId_assigned == obj.id) {
                                    var photos: Photos[] = [];
                                    for (let obj of this.list_photos) {
                                      if (item.id == obj.item_evidence_id) {
                                        photos.push({
                                          photo_name: obj.photo_name,
                                          thumb_name: obj.thumb_name,
                                          url_photo: obj.url_photo,
                                          url_thumb: obj.url_thumb,
                                        });
                                      }
                                    }

                                    this.array_evidence.push({
                                      id: item.id,
                                      title: obj.title,
                                      descripcion: item.description,
                                      evidencia: photos,
                                    });
                                  }
                                }
                              }
                            } else {
                              var photos: Photos[] = [];
                              for (let obj of this.list_photos) {
                                if (item.id == obj.item_evidence_id) {
                                  photos.push({
                                    photo_name: obj.photo_name,
                                    thumb_name: obj.thumb_name,
                                    url_photo: obj.url_photo,
                                    url_thumb: obj.url_thumb,
                                  });
                                }
                              }

                              this.array_evidence.push({
                                id: item.id,
                                title: "Foto Evidencia",
                                descripcion: item.description,
                                evidencia: photos,
                              });
                            }
                          }
                        }

                        this.setSignatures();
                      }
                    })
                    .catch((err) => {
                      console.log("Error al obtener las photos.");
                    });
                })
                .catch((err1) => {
                  console.log("Err 1 -> " + err1);
                });
            })
            .catch((error) => {
              console.log("Error al obtener los items -> " + error);
            });
        } else {
          console.log("No se encontro evidencia para la orden.");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setSignatures() {
    this.list_signatures = [];
    this.getAllUrlSignaturesByOrder()
      .then((res) => {
        if (res) {
          console.log("Firmas cargadas correctamente.");

          this.loadAllQuestionariesByOrder()
            .then((result) => {
              if (result) {
                this.loadAllCommentsByOrder()
                  .then((result1) => {
                    if (result1) {
                      console.log("Comentarios cargados correctamente.");

                      this.preparePDF().then((ok) => {
                        if (ok) {
                          this.userService
                            .createNewReport(this.template)
                            .then((id_report) => {
                              var url_customer =
                                this.authService.customerSelected.url_pdf;

                              const link = document.createElement("a");
                              link.target = "_blank";
                              var url_full =
                                url_customer + "?report_id=" + id_report;
                              link.href = url_full;
                              link.setAttribute("visibility", "hidden");
                              link.click();
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }
                      });
                    }
                  })
                  .catch((err) => {
                    console.log("Error al obtener los comentarios. -> " + err);
                  });
              }
            })
            .catch((err) => {
              console.log("Error al obtener las preguntas. -> " + err);
            });
        } else {
          console.log("no firmas");
        }
      })
      .catch(() => {
        console.log("Error al obtener las photos.");
      });
  }

  getAllUrlPhotosByOrder() {
    return new Promise((resolve, reject) => {
      this.list_photos = [];
      var contador = 0;
      var num_photos = 0;

      for (let item of this.order_pdf.evidence) {
        if (item.photos.length > 0) {
          num_photos += item.photos.length;
        }
      }

      if (num_photos > 0) {
        for (let item of this.order_pdf.evidence) {
          if (item.photos.length > 0) {
            for (let photo of item.photos) {
              this.userService.customerDB.app
                .storage()
                .ref(
                  this.order_pdf.user_uid +
                    "/orders/" +
                    this.order_pdf.id +
                    "/evidence/" +
                    item.id +
                    "/"
                )
                .child(photo.photo_name)
                .getDownloadURL()
                .then((URL) => {
                  contador += 1;
                  this.list_photos.push({
                    item_evidence_id: item.id,
                    photo_name: photo.photo_name,
                    thumb_name: photo.thumb_name,
                    url_photo: URL,
                    url_thumb: "",
                  });

                  if (contador == num_photos) {
                    resolve(true);
                  }
                })
                .catch((err) => {
                  console.log("Error al obtener foto url: " + err);
                });
            }
          }
        }
      } else {
        resolve(true);
      }
    });
  }

  getAllUrlSignaturesByOrder() {
    return new Promise((resolve, reject) => {
      var contador = 0;
      var num_firmas = 0;

      for (let item of this.order_pdf.evidence) {
        if (item.last_signed_name != "") {
          num_firmas += 1;
        }
      }

      console.log("Total de firmas -> " + num_firmas);
      if (num_firmas > 0) {
        this.array_signatures = [];
        for (let item of this.order_pdf.evidence) {
          if (item.last_signed_name != "") {
            console.log("Item Asignado -> " + item.itemId_assigned);
            if (item.itemId_assigned != undefined) {
              if (item.itemId_assigned == 0) {
                this.userService.customerDB.app
                  .storage()
                  .ref(
                    this.order_pdf.user_uid +
                      "/orders/" +
                      this.order_pdf.id +
                      "/evidence/" +
                      item.id +
                      "/"
                  )
                  .child(item.last_signed_name)
                  .getDownloadURL()
                  .then((URL) => {
                    contador += 1;
                    this.list_signatures.push({
                      item_evidence_id: item.id,
                      signature_name: item.last_signed_name,
                      signed_customer_name: item.last_signed_customer_name,
                      url: URL,
                    });

                    this.array_signatures.push({
                      title: "Firmas",
                      firmas: this.list_signatures,
                    });

                    if (contador == num_firmas) {
                      resolve(true);
                    }
                  })
                  .catch((err) => {
                    console.log("Error al obtener firma url: " + err);
                  });
              } else {
                for (let obj of this.items_config) {
                  if (item.itemId_assigned == obj.id) {
                    this.userService.customerDB.app
                      .storage()
                      .ref(
                        this.order_pdf.user_uid +
                          "/orders/" +
                          this.order_pdf.id +
                          "/evidence/" +
                          item.id +
                          "/"
                      )
                      .child(item.last_signed_name)
                      .getDownloadURL()
                      .then((URL) => {
                        contador += 1;
                        this.list_signatures.push({
                          item_evidence_id: item.id,
                          signature_name: item.last_signed_name,
                          signed_customer_name: item.last_signed_customer_name,
                          url: URL,
                        });

                        this.array_signatures.push({
                          id: item.id,
                          title: obj.title,
                          firmas: this.list_signatures,
                        });
                        this.list_signatures = [];

                        if (contador == num_firmas) {
                          console.log("***End***");
                          resolve(true);
                        }
                      })
                      .catch((err) => {
                        console.log("Error al obtener firma url: " + err);
                      });
                  }
                }
              }
            } else {
              this.userService.customerDB.app
                .storage()
                .ref(
                  this.order_pdf.user_uid +
                    "/orders/" +
                    this.order_pdf.id +
                    "/evidence/" +
                    item.id +
                    "/"
                )
                .child(item.last_signed_name)
                .getDownloadURL()
                .then((URL) => {
                  contador += 1;
                  this.list_signatures.push({
                    item_evidence_id: item.id,
                    signature_name: item.last_signed_name,
                    signed_customer_name: item.last_signed_customer_name,
                    url: URL,
                  });

                  this.array_signatures.push({
                    title: "Firmas",
                    firmas: this.list_signatures,
                  });

                  if (contador == num_firmas) {
                    resolve(true);
                  }
                })
                .catch((err) => {
                  console.log("Error al obtener firma url: " + err);
                });
            }
          }
        }
      } else {
        resolve(true);
      }
    });
  }

  loadAllQuestionariesByOrder() {
    return new Promise((resolve, reject) => {
      var contador = 0;
      for (let item of this.order_pdf.evidence) {
        if (item.title == "") {
          if (item.questions.length > 0) {
            contador = contador + 1;
          }
        }
      }

      if (contador > 0) {
        for (let item of this.order_pdf.evidence) {
          if (item.questions.length > 0) {
            if (item.itemId_assigned != undefined) {
              if (item.itemId_assigned == 0) {
                this.array_questionaries.push({
                  title: "Cuestionario",
                  questions: item.questions,
                });
                if (contador == this.array_questionaries.length) {
                  resolve(true);
                }
              } else {
                for (let obj of this.items_config) {
                  if (item.itemId_assigned == obj.id) {
                    if (item.title == "") {
                      this.array_questionaries.push({
                        id: obj.id,
                        title: obj.title,
                        questions: item.questions,
                      });
                      if (contador == this.array_questionaries.length) {
                        //ordenar ids de menor a mayor
                        this.array_questionaries =
                          this.array_questionaries.sort(
                            (n1, n2) => n1.id - n2.id
                          );
                        resolve(true);
                      }
                    }
                  }
                }
              }
            } else {
              this.array_questionaries.push({
                title: "Cuestionario",
                questions: item.questions,
              });
              resolve(true);
            }
          }
        }
      } else {
        resolve(true);
      }
    });
  }

  loadAllCommentsByOrder() {
    return new Promise((resolve, reject) => {
      var contador = 0;
      for (let item of this.order_pdf.evidence) {
        if (item.title == "COMENTARIOS") {
          if (item.questions.length > 0) {
            contador = contador + 1;
          }
        }
      }

      if (contador > 0) {
        for (let item of this.order_pdf.evidence) {
          if (item.questions.length > 0) {
            if (item.itemId_assigned != undefined) {
              if (item.itemId_assigned == 0) {
                this.array_comments.push({
                  title: "Comentarios",
                  questions: item.questions,
                });
                if (contador == this.array_comments.length) {
                  resolve(true);
                }
              } else {
                for (let obj of this.items_config) {
                  if (item.itemId_assigned == obj.id) {
                    if (item.title == "COMENTARIOS") {
                      this.array_comments.push({
                        id: obj.id,
                        title: obj.title,
                        questions: item.questions,
                      });
                      if (contador == this.array_comments.length) {
                        //ordenar ids de menor a mayor
                        this.array_comments = this.array_comments.sort(
                          (n1, n2) => n1.id - n2.id
                        );
                        resolve(true);
                      }
                    }
                  }
                }
              }
            } else {
              this.array_comments.push({
                title: "Comentarios",
                questions: item.questions,
              });
              resolve(true);
            }
          }
        }
      } else {
        resolve(true);
      }
    });
  }

  preparePDF() {
    return new Promise((resolve, reject) => {
      /*********************Pintar Fotos*********************/
      var template_evidencias = "";

      console.log("Numero de Albums -> " + JSON.stringify(this.array_evidence));

      /****************Pintar Preguntas *****************/
      if (this.array_questionaries.length > 0) {
        var template_questions = "";

        for (let album_questions of this.array_questionaries) {
          var header_div =
            '<div class="no-break clearfix">' +
            '<div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
            '   <div class="image_items">' +
            '     <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_done.png?alt=media&token=9501497d-a853-4943-8547-664fa60a352e" alt="" />' +
            "   </div>" +
            '   <div class="label" style="padding-left:10px;">' +
            "     <label>" +
            album_questions.title +
            "</label>" +
            "   </div>" +
            " </div>" +
            "</div>" +
            ' <TABLE style="width:100%; padding:10px">';

          var end_table_q = "</TABLE>" + '<HR id="line">';

          var filas_tmp: string = "";

          for (let x = 0; x < album_questions.questions.length; x++) {
            var _row = "";
            if (album_questions.questions[x].type == "check") {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (
              album_questions.questions[x].type == "input" ||
              album_questions.questions[x].type == "dropdown" ||
              album_questions.questions[x].type == "textarea"
            ) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (!album_questions.questions[x].isOpenQuestion) {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (album_questions.questions[x].isOpenQuestion) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            }

            filas_tmp = filas_tmp + _row;
          }

          template_questions =
            template_questions + header_div + filas_tmp + end_table_q;
        }

        template_evidencias = template_evidencias + template_questions;
      }

      if (this.array_evidence.length > 0) {
        for (let album of this.array_evidence) {
          var template_album = "";
          var table = "";

          var number_photos = album.evidencia.length;
          var filas = number_photos / 2;
          var number_rows = Math.ceil(filas);
          var number_cols_tot = number_rows * 2;
          var number_cols_empty = number_cols_tot - album.evidencia.length;

          var header_div =
            '<div class="break-before">' +
            '  <div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
            '    <div class="image_items">' +
            '       <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_insert_photo.png?alt=media&token=4b4ea0de-1c04-484e-9300-9e2a5a26fb34" alt="" />' +
            "    </div>" +
            '    <div class="label" style="padding-left:10px;">' +
            "      <label>" +
            album.title +
            "</label>" +
            "    </div>" +
            "  </div>" +
            ' <TABLE style="width:100%; padding:10px">';

          var end_table = "   </TABLE>" + '   <HR id="line"> ' + "</div>";

          //Obtener los td's con fotos
          var arr_tds = [];
          for (let x = 0; x < album.evidencia.length; x++) {
            var td =
              '<td width="50%">' +
              '  <img style = "width: 95%; object-fit: contain; " src = "' +
              album.evidencia[x].url_photo +
              '" id="evidence">' +
              "</td>";
            arr_tds.push(td);
          }

          //Obtener los td's vacios
          for (let y = 0; y < number_cols_empty; y++) {
            var td = '<td width="50%">' + "&nbsp;" + "</td>";
            arr_tds.push(td);
          }

          var cont = 0;

          for (let i = 0; i < arr_tds.length; i++) {
            var row = "";

            if (cont == 0) {
              row = row + "<tr>";
            }

            if (cont < 1) {
              row = row + arr_tds[i];
            }

            if (cont == 1) {
              row = row + arr_tds[i];
              row = row + "</tr>";
              cont = 0;
            } else {
              cont = cont + 1;
            }

            table = table + row;
          }

          template_album = header_div + table + end_table;

          template_evidencias = template_evidencias + template_album;
        } // End for
      }

      /*********************Pintar las firmas*********************/
      if (this.array_signatures.length > 0) {
        var isFirstSignature = true;
        for (let album_firma of this.array_signatures) {
          if (isFirstSignature) {
            var div_title_firmas =
              '<div class="break-before">' +
              '  <div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
              '     <div class="image_items">' +
              '       <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_firma.png?alt=media&token=6afce37f-c7d1-410d-95fa-aeb0ce3bd0fb" alt="" />' +
              "    </div>" +
              '    <div class="label" style="padding-left:10px;">' +
              "       <label>" +
              album_firma.title +
              "</label>" +
              "    </div>" +
              "  </div>" +
              "</div>";

            isFirstSignature = false;
          } else {
            var div_title_firmas =
              '<div class=".no-break">' +
              '  <div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
              '     <div class="image_items">' +
              '       <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_firma.png?alt=media&token=6afce37f-c7d1-410d-95fa-aeb0ce3bd0fb" alt="" />' +
              "    </div>" +
              '    <div class="label" style="padding-left:10px;">' +
              "       <label>" +
              album_firma.title +
              "</label>" +
              "    </div>" +
              "  </div>" +
              "</div>";
          }

          var start_table =
            '<div style="width:770px;">' +
            '<TABLE style="width:100%; table-layout: fixed;">';

          var end_table = "</TABLE>" + "</div>";
          //'<HR id="line">';

          var template_firmas = "";
          var table = "";

          var number_photos = album_firma.firmas.length;
          var filas = number_photos / 2;
          var number_rows = Math.ceil(filas);
          var number_cols_tot = number_rows * 2;
          var number_cols_empty = number_cols_tot - album_firma.firmas.length;

          //Obtener los td's con firmas
          var arr_tds = [];
          for (let x = 0; x < album_firma.firmas.length; x++) {
            var td =
              '<td width="45%" style="text-align: center; padding: 5px">' +
              '<img style="object-fit: contain; width: 90%; height: 50%;" src="' +
              album_firma.firmas[x].url +
              '" id="evidence">' +
              '<HR id="line">' +
              "</br><label>" +
              album_firma.firmas[x].signed_customer_name +
              "</label>" +
              "</td>";
            arr_tds.push(td);
          }

          //Obtener los td's vacios
          for (let y = 0; y < number_cols_empty; y++) {
            var td = '<td width="45%">' + "&nbsp;" + "</td>";
            arr_tds.push(td);
          }

          //Ajustar td y tr
          var cont = 0;
          for (let i = 0; i < arr_tds.length; i++) {
            var row = "";

            if (cont == 0) {
              row = row + "<tr>";
            }

            if (cont < 1) {
              row = row + arr_tds[i];
            }

            if (cont == 1) {
              row = row + arr_tds[i];
              row = row + "</tr>";
              cont = 0;
            } else {
              cont = cont + 1;
            }

            table = table + row;
          }

          template_firmas = div_title_firmas + start_table + table + end_table;
          template_evidencias = template_evidencias + template_firmas;
        }
      }

      /****************Pintar Comentarios *****************/
      if (this.array_comments.length > 0) {
        var template_questions = "";

        for (let album_questions of this.array_comments) {
          var header_div =
            '<div class="no-break clearfix">' +
            '<div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
            '   <div class="image_items">' +
            '     <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_drive.png?alt=media&token=313f61fa-f049-4114-b947-afaa9cd00e16" alt="" />' +
            "   </div>" +
            '   <div class="label" style="padding-left:10px;">' +
            "     <label>" +
            album_questions.title +
            "</label>" +
            "   </div>" +
            " </div>" +
            "</div>" +
            ' <TABLE style="width:100%; padding:10px">';

          var end_table_q = "</TABLE>" + '<HR id="line">';

          var filas_tmp: string = "";

          for (let x = 0; x < album_questions.questions.length; x++) {
            var _row = "";
            if (album_questions.questions[x].type == "check") {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (
              album_questions.questions[x].type == "input" ||
              album_questions.questions[x].type == "dropdown" ||
              album_questions.questions[x].type == "textarea"
            ) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (!album_questions.questions[x].isOpenQuestion) {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (album_questions.questions[x].isOpenQuestion) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            }

            filas_tmp = filas_tmp + _row;
          }

          template_questions =
            template_questions + header_div + filas_tmp + end_table_q;
        }

        template_evidencias = template_evidencias + template_questions;
      }

      /**************************************************/
      var template_materiales = "";
      console.log("Tabla evidencias -> " + template_evidencias);

      var html_template: string = this.template_pdf;
      console.log("HTML ACTUAL -> " + html_template);

      var fecha_arr = this.order_pdf.start_date.split(" ");
      var fecha = fecha_arr[0];
      var hi = fecha_arr[1];

      var fecha_end = this.order_pdf.end_date.split(" ");
      var he = fecha_end[1];

      console.log("ORDEN -> " + JSON.stringify(this.order_pdf));

      /* Replace Order number */
      html_template = html_template.replace("{0}", this.order_pdf.order_number);
      /* Replace Order Customer Name */
      html_template = html_template.replace(
        "{1}",
        this.order_pdf.customer_name
      );
      /* Replace Order Address */
      html_template = html_template.replace(
        "{2}",
        this.order_pdf.address_checkIn
      );
      /* Replace Order CheckIn Date */
      html_template = html_template.replace("{3}", hi);
      //html_template = html_template.replace(new RegExp('{3}', 'g'), this.order.start_date);
      /* Replace Order CheckOut Date */
      html_template = html_template.replace("{4}", he);
      /* Replace Order Materiales */
      html_template = html_template.replace("{5}", template_materiales);
      /* Replace Order Photo Evidence */
      html_template = html_template.replace("{6}", template_evidencias);
      /* Replace Nombre de la orden o evento */
      html_template = html_template.replace("{10}", this.order_pdf.order_name);
      /* Replace Address CheckIn */
      html_template = html_template.replace(
        "{11}",
        this.order_pdf.address_checkIn
      );
      /* Replace Usuario */
      html_template = html_template.replace("{12}", this.order_pdf.user_name);
      /* Replace URL MAP */
      html_template = html_template.replace("{13}", this.url_map);
      /* Replace Fecha */
      html_template = html_template.replace("{14}", fecha);
      /* Replace Order Duration */
      html_template = html_template.replace(
        "{15}",
        this.toDuration(this.order_pdf.start_date, this.order_pdf.end_date)
      );
      /* Replace Logo Client */
      var logo = '<img src= "' + this.url_logo_client + '" id="img_logo">';
      html_template = html_template.replace("{16}", logo);
      /* Replace URL_PDF */
      html_template = html_template.replace("{17}", this.url_link);

      this.template = html_template;

      resolve(true);
    });
  }

  filterOrdenes(orden: ordenesObj, filter: string): boolean {
    let _allIncidences = false;
    let _incidences = filter
      .trim()
      .split(" ")
      .filter((s) => s.trim() != "");
    let _totalIncidences = _incidences.length;

    let _currentIncidences = 0;
    _incidences.forEach((i) => {
      if (
        this.utilsService.search(orden, "address", i) ||
        this.utilsService.search(orden, "address_checkIn", i) ||
        this.utilsService.search(orden, "customer_name", i) ||
        this.utilsService.search(orden, "description_photo_evidence", i) ||
        this.utilsService.search(orden, "order_name", i) ||
        this.utilsService.search(orden, "order_number", i)
      ) {
        _currentIncidences++;
      }
    });

    return _totalIncidences === _currentIncidences;
  }

  toDuration(start_date: string, end_date: string) {
    let start_moment = Moment(start_date),
      end_moment = Moment(end_date);

    if (!end_moment.isValid() || !start_moment.isValid()) return "0 minutes";

    let total_minutes = 78; // end_moment.diff(start_moment, 'minutes');

    let secs = end_moment.diff(start_moment, "seconds");
    var hours = Math.floor(secs / (60 * 60));

    var divisor_for_minutes = secs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);

    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);

    var obj = {
      h: hours || 0,
      m: minutes || 0,
      s: seconds || 0,
    };

    return (
      (obj.h > 0 ? `${obj.h} hours ` : "") +
      (obj.m > 0 ? `${obj.m} minutes ` : "") +
      (obj.s > 0 ? `${obj.s} seconds` : "")
    );
  }

  toMiniDashboardLabel(sec: number) {
    var hours = Math.floor(sec / (60 * 60));

    var divisor_for_minutes = sec % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);

    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);

    var obj = {
      h: hours || 0,
      m: minutes || 0,
      s: seconds || 0,
    };
    if (obj.h > 24)
      return `${Math.floor(obj.h / 24)}day ${Math.floor(obj.h % 24)}hrs`;
    else if (obj.h > 0) return `${obj.h}:${obj.m}hrs`;
    else if (obj.m > 0) return `${obj.m}:${obj.s}min`;
    else return `${obj.s}sec`;
  }

  selectedUsers(event) {
    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedPersonId_string = "";
    }

    if (event != null) {
      this.selectedPersonId_string = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });
      this.selectedPersonId = valueid;
      if (valueid_string != "")
        this.selectedPersonId_string = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedPersonId_string);
    }
  }

  selectedTipos(event) {
    console.log("EVENTO RECI ... ", event);
    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedTipoIdstring = "";
    }

    if (event != null) {
      this.selectedTipoIdstring = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });
      this.selectedTipoId = valueid;
      if (valueid_string != "")
        this.selectedTipoIdstring = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedTipoIdstring);
    }
    //this.selectedTipoId = event;
    // this.tipos = [];
  }

  selectedSucursal(event) {
    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedSucursalIdstring = "";
    }

    if (event != null) {
      this.selectedSucursalIdstring = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });
      this.selectedSucursalId = valueid;
      if (valueid_string != "")
        this.selectedSucursalIdstring = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedSucursalIdstring);
    }

    this.selectedSucursalId = event;
  }

  selectedDepartamentos(event) {
    //this.selectedDepartmentId = event;
    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedDepartmentId_string = "";
    }

    if (event != null) {
      this.selectedDepartmentId_string = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });
      this.selectedDepartmentId = valueid;
      if (valueid_string != "")
        this.selectedDepartmentId_string = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedDepartmentId_string);
    }
  }

  selectedClientes(event) {
    //this.selectedClienteId = event;
    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedClienteIdstring = "";
    }

    if (event != null) {
      this.selectedClienteIdstring = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });
      this.selectedClienteId = valueid;
      if (valueid_string != "")
        this.selectedClienteIdstring = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedClienteIdstring);
    }
  }

  selectedEquipments(event) {
    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedEquipmentstring = "";
    }

    if (event != null) {
      this.selectedEquipmentstring = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });
      this.selectedEquipmentId = valueid;
      if (valueid_string != "")
        this.selectedEquipmentstring = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedEquipmentstring);
    }
  }

  selectedCategories(event) {
    //this.selectedCategoryId = event;

    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedCategoryIdstring = "";
    }

    if (event != null) {
      this.selectedCategoryIdstring = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });
      this.selectedCategoryId = valueid;

      if (valueid_string != "")
        this.selectedCategoryIdstring = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedCategoryIdstring);
    }
  }

  selectedSubcategories(event) {
    //this.selectedSubcategoryId = event;
    let valueid = [];
    let valueid_string = "";
    console.log("~ event1", event);
    if (event == null) {
      this.selectedSubCategoryIdstring = "";
    }

    if (event != null) {
      this.selectedSubcategoryIdstring = "";
      event.forEach((element) => {
        valueid.push(element.id);
        valueid_string += "'" + element.id + "'" + ",";
      });

      this.selectedSubcategoryId = valueid;
      if (valueid_string != "")
        this.selectedSubCategoryIdstring = valueid_string.substring(
          0,
          valueid_string.length - 1
        );
      console.log("~ event", this.selectedSubCategoryIdstring);
    }
  }

  changeSearch(event) {
    console.log(event);
    this.isSearching = true;
    this.user_selected = event;
    console.log("~ this.user_selected", this.user_selected);
  }

  exportAsXLSX(): void {
    let data: any = this.MarkersVisible.map((m) => {
      const ruta = "/" + this.storageService.getCurrentDB() + "/detail-order";
      let url = `${window.location.protocol}//${window.location.host}`;
      url =
        url +
        this.router.serializeUrl(
          this.router.createUrlTree([ruta], {
            queryParams: {
              order_uui: m.id,
            },
          })
        );

      return {
        Nombre: m.order_name,
        "Numero de Orden": m.order_number,
        Fecha: m.start_date,
        CheckIn: m.start_date,
        CheckOut: m.end_date,
        Duración: this.toDuration(m.start_date, m.end_date),
        Usuario: m.user_name,
        URL: url,
      };
    });
    this.excelService.exportAsExcelFile(data, "ReporteTrackPoint");
  }

  openShareEvent(order: ordenesObj) {
    console.error();

    if (order.dynamic_url_web) {
      let urlEvento = order.dynamic_url_web;

      this.dialog.open(ShareDialogComponent, {
        height: "230px",
        width: "600px",
        data: {
          urlEvento,
        },
      });
    } else {
      if (this.storageService.getCurrentDB() != "") {
        const urlEvento =
          this.authService.customerSelected.url_report + order.id;

        this.ordersService
          .getInfoOrderWithUrl(order.id, urlEvento)
          .subscribe((respose: any) => {
            console.error(respose);
            let urlEvento = respose.data.dynamic_url_web;
            console.log("~ urlEvento", urlEvento);

            this.dialog.open(ShareDialogComponent, {
              height: "230px",
              width: "600px",
              data: {
                urlEvento,
              },
            });
          });
      }
    }
  }

  /* Angular Gallery */

  openGallery(order_galery: any) {
    var i = order_galery.id;
    this.current_order = order_galery.order;
    this.currentImages = [];
    this.current_order.photo_evidence.forEach((p, i) =>
      this.currentImages.push(
        new Image(i, { img: p.url_photo, description: p.caption })
      )
    );
    setTimeout(() => {
      const images: any = document.getElementsByClassName("image")[i];
      images.click();
    }, 350);
  }

  onCloseImageModal() {
    this.currentImages = [];
  }

  async goReports(order: ordenesObj) {
    console.log("CAAAAAA ORDE ", order);
    this.all_reports = [];
    this.showEmptyReports = false;

    //this.userService.customerSelected = this.authService.customerSelected;
    await //this.userService.customerDB.app
    //.firestore()
    this.userService
      .getTenancyParams()
      .collection("modules")
      .where("category", "==", order.category)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(async (doc: any) => {
          var reports = doc.data().reports;

          if (reports) {
            await reports.forEach((i) => {
              i.get().then(async (property) => {
                if (property.data().available) {
                  this.all_reports.push(property.data());

                  if (this.all_reports.length <= 0) {
                    this.showEmptyReports = true;
                  }
                } else {
                  this.showEmptyReports = true;
                }
              });
            });
          } else {
            this.showEmptyReports = true;
          }
        });
      })
      .catch((err) => {
        console.log("Error Firebae -> " + err);
      });
  }

  archivedOrder(order): void {
    this.modalGeneric
      .onModelconfirmacion(
        false, //disableClose
        this.translateService.instant("PAGES.DASHBOARD.ARCHIVED_CONFIRM"), //message
        true, // cancelButton
        this.translateService.instant(
          "PAGES.USER_LIST.LIST.THUMBNAIL.CONFIRM_DELETE"
        ), //confimButtonText
        true, // info
        false //imagen info
        //title
      )
      .afterClosed()
      .pipe(take(1))
      .subscribe((resp) => {
        if (resp === "aceptar") {
          this.spinner.show();
          this.cd.detectChanges();
          this.ordersService
            .archivedOrder({ order: { id: order.id } })
            .subscribe((response) => {
              this.spinner.hide();
              this.cd.detectChanges();
              if (response.status === "ok") {
                this.modalGeneric
                  .onModelexito(
                    false, //disableClose
                    this.translateService.instant(
                      "PAGES.DASHBOARD.ARCHIVED_OK"
                    ), //message
                    false, // cancelButton
                    this.translateService.instant("MESSAGE.ACEPTAR"), //confimButtonText
                    true, // info
                    false //imagen info
                  )
                  .afterClosed()
                  .pipe(take(1))
                  .subscribe(() => {
                    this.order_pin_selected.id = null;
                    console.log("1111111111111 1 ");
                    this.Period();
                  });
              } else {
                this.spinner.hide();
                this.cd.detectChanges();
                this.modalGeneric.onModelerror(
                  false, //disableClose
                  this.translateService.instant(
                    "PAGES.DASHBOARD.ARCHIVED_ERROR"
                  ), //message
                  false, // cancelButton
                  this.translateService.instant("MESSAGE.ACEPTAR"), //confimButtonText
                  true, // info
                  false //imagen info
                );
              }
            });
        }
      });
  }

  transferOrder(order): void {
    console.log("ORDER TO TRANSFER ", order);

    const dialogRef = this.dialog.open(TransferActivityComponent, {
      height: "auto",
      width: "40%",
      data: {
        order: order,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((data) => {
        console.log("DATA ", data);
        if (data == "OK") {
          this.order_pin_selected.id = null;
          console.log("1111111111111 2-12 ");
          this.Period();
        }

        if (data == "err") {
          this.modalGeneric.onModelerror(
            false, //disableClose
            this.translateService.instant("PAGES.TRANSFER_ACTIVITY.ERROR"), //message
            false, // cancelButton
            this.translateService.instant("MESSAGE.ACEPTAR"), //confimButtonText
            true, // info
            false //imagen info
          );
        }
      });
  }

  deletedOrder(order): void {
    this.modalGeneric
      .onModelconfirmacion(
        false, //disableClose
        this.translateService.instant("PAGES.DASHBOARD.DELETED_CONFIRM"), //message
        true, // cancelButton
        this.translateService.instant(
          "PAGES.USER_LIST.LIST.THUMBNAIL.CONFIRM_DELETE"
        ), //confimButtonText
        true, // info
        false //imagen info
        //title
      )
      .afterClosed()
      .pipe(take(1))
      .subscribe((resp) => {
        if (resp === "aceptar") {
          this.spinner.show();
          this.cd.detectChanges();
          this.ordersService
            .deletedOrder({ order: { id: order.id } })
            .subscribe((response) => {
              this.spinner.hide();
              this.cd.detectChanges();
              if (response.status === "ok") {
                this.modalGeneric
                  .onModelexito(
                    false, //disableClose
                    this.translateService.instant("PAGES.DASHBOARD.DELETED_OK"), //message
                    false, // cancelButton
                    this.translateService.instant("MESSAGE.ACEPTAR"), //confimButtonText
                    true, // info
                    false //imagen info
                  )
                  .afterClosed()
                  .pipe(take(1))
                  .subscribe(() => {
                    this.order_pin_selected.id = null;
                    console.log("1111111111111 2 ");
                    this.Period();
                  });
              } else {
                this.spinner.hide();
                this.cd.detectChanges();
                this.modalGeneric.onModelerror(
                  false, //disableClose
                  this.translateService.instant(
                    "PAGES.DASHBOARD.DELETED_ERROR"
                  ), //message
                  false, // cancelButton
                  this.translateService.instant("MESSAGE.ACEPTAR"), //confimButtonText
                  true, // info
                  false //imagen info
                );
              }
            });
        }
      });
  }

  getReportSelected(order, report) {
    const url_file = report.url_file + order.id;
    const link = document.createElement("a");
    link.target = "_blank";
    link.href = url_file;
    link.download = "reporte.xlsx";
    link.setAttribute("visibility", "hidden");
    link.click();
  }

  opensearchform() {
    this.isSearching2 = true;
    this.changemapstyle();
  }

  closesearchform() {
    this.isSearching2 = false;
    this.stylewidth = "100%";
    this.isSearching = false;
    this.storageService.removeFiltersDashboard();
  }

  onChangeEstatus(estatus) {
    this.estatusSelect = estatus;
    this.statusSelect = estatus;

    this.isSearching = true;
    console.log("1111111111111 3 ");
    this.Period();
  }

  filterSearch(filter) {
    this.filter_apply = filter;

    this.isSearching = true;
    console.log("1111111111111 4 ");
    this.Period();
  }

  filterOrdenesAll(ordenes) {
    let filter = this.filter_apply;
    let estatus = this.statusSelect;
    var ordenes_filtradas: ordenesObj[] = ordenes;

    console.log("filter filter ", filter);
    console.log("estatus estatus ", estatus);

    this.ordenes = [];
    this.ordenes = this.ordenes_clone;

    if (filter != "") {
      ordenes_filtradas = ordenes_filtradas.filter(function (orden) {
        if (
          orden.order_name != undefined &&
          orden.order_number != undefined &&
          orden.tipo != undefined &&
          orden.user_name != undefined &&
          orden.address_checkIn != undefined
        ) {
          return (
            orden.order_name.toLowerCase().includes(filter.toLowerCase()) ||
            orden.order_number.toLowerCase().includes(filter.toLowerCase()) ||
            orden.tipo.toLowerCase().includes(filter.toLowerCase()) ||
            orden.user_name.toLowerCase().includes(filter.toLowerCase()) ||
            orden.address_checkIn.toLowerCase().includes(filter.toLowerCase())
          );
        }
      });
    }

    // ['Todas', 'Abiertas', 'Cerradas', 'En revisión', 'Autorizadas', 'Rechazadas', 'Archivadas'];

    if (estatus != "Todas") {
      if (estatus == "Abiertas") {
        ordenes_filtradas = ordenes_filtradas.filter(
          (orden) => orden.status === "2"
        );
      } else if (estatus == "Cerradas") {
        ordenes_filtradas = ordenes_filtradas.filter(
          (orden) => orden.status === "3"
        );
      } else if (estatus == "En revisión") {
        ordenes_filtradas = ordenes_filtradas.filter(
          (orden) => orden.status === "3" && orden.authorization_status === 1
        );
      } else if (estatus == "Autorizadas") {
        ordenes_filtradas = ordenes_filtradas.filter(
          (orden) => orden.status === "3" && orden.authorization_status === 2
        );
      } else if (estatus == "Rechazadas") {
        ordenes_filtradas = ordenes_filtradas.filter(
          (orden) => orden.status === "2" && orden.authorization_status === 3
        );
      } else if (estatus == "Archivadas") {
        ordenes_filtradas = ordenes_filtradas.filter(
          (orden) => orden.status === "4"
        );
      }
    }

    if (estatus != "Todas" || filter != "") {
      this.ordenes = [];
      this.ordenes = ordenes_filtradas;
      this.ordenes$ = this.getOrdenes();
      this.refresh();
    }
  }

  clearSearch() {
    this.filter_apply = "";
    this.onChangeEstatus(this.statusSelect);
  }

  clearFilterStatus() {
    this.onChangeEstatus("Todas");
  }

  changueMenu(menu) {
    console.log("MEEENUU ", menu);
    if (menu == "grid") {
      this.orders_by_block = 50;
      this.selectMenu = true;
    } else if (menu == "list") {
      this.selectMenu = false;
      this.orders_by_block = 100;
    }
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;

    this.scrWidth = window.innerWidth;
    this.changemapstyle();
    console.log(this.scrHeight, this.scrWidth);
  }

  private changemapstyle() {
    if (this.isSearching2 == true) {
      if (this.scrWidth == 1920) {
        this.stylewidth = "83%";
      } else if (this.scrWidth >= 1700) {
        this.stylewidth = "80%";
      } else if (this.scrWidth >= 1500) {
        this.stylewidth = "78%";
      } else if (this.scrWidth >= 1400) {
        this.stylewidth = "77%";
      }
    }
  }

  round(value) {
    return Math.ceil(value);
  }

  updateCurrentPage(value) {
    console.log("ENTER updateCurrentPage ");
    try {
      if (this.orders_by_block !== 1) {
        if (value == 1) {
          this.pageActual = 1;
        }
      }
    } catch (err) {}
  }
}
